export interface CityData {
  slug: string;
  name: string;
  state: string;
  county: string;
  description: string;
  description_es: string;
  highlights: string[];
  highlights_es: string[];
  services: string[];
  services_es: string[];
  keywords: string[];
  metaDescription: string;
  metaDescription_es: string;
}

export const CITY_DATA: CityData[] = [
  {
    slug: "miami",
    name: "Miami",
    state: "Florida",
    county: "Miami-Dade County",
    description:
      "Miami is a vibrant, cosmopolitan city known for its stunning beaches, world-class dining, and thriving cultural scene. As one of the most sought-after real estate markets in the United States, Miami offers everything from luxurious waterfront estates in Coconut Grove to modern high-rise condos in Brickell and edgy lofts in Wynwood. The city's booming economy, favorable tax climate, and international appeal make it a top destination for buyers and investors alike.",
    description_es:
      "Miami es una ciudad vibrante y cosmopolita, reconocida por sus impresionantes playas, gastronomía de primer nivel y una escena cultural en auge. Como uno de los mercados inmobiliarios más codiciados de Estados Unidos, Miami ofrece desde lujosas propiedades frente al mar en Coconut Grove hasta modernos condominios de gran altura en Brickell y lofts de vanguardia en Wynwood. La floreciente economía de la ciudad, su favorable clima fiscal y su atractivo internacional la convierten en un destino principal tanto para compradores como para inversores.",
    highlights: [
      "Major international business hub with no state income tax",
      "Home to Art Basel, the Pérez Art Museum, and a thriving nightlife",
      "Year-round tropical climate with average temperatures of 76°F",
      "Top-rated dining scene with James Beard Award–winning restaurants",
    ],
    highlights_es: [
      "Importante centro de negocios internacional sin impuesto estatal sobre la renta",
      "Hogar de Art Basel, el Pérez Art Museum y una vibrante vida nocturna",
      "Clima tropical todo el año con temperaturas promedio de 24°C",
      "Gastronomía de primera categoría con restaurantes galardonados por James Beard",
    ],
    services: [
      "Luxury condo sales in Brickell & Downtown Miami",
      "Waterfront estate brokerage in Coconut Grove & Coral Way",
      "Investment property analysis and portfolio management",
      "New construction pre-sale representation",
      "Bilingual real estate services (English & Spanish)",
      "Relocation assistance for domestic and international buyers",
    ],
    services_es: [
      "Venta de condominios de lujo en Brickell y Downtown Miami",
      "Corretaje de propiedades frente al mar en Coconut Grove y Coral Way",
      "Análisis de propiedades de inversión y gestión de carteras",
      "Representación en preventa de construcciones nuevas",
      "Servicios inmobiliarios bilingües (inglés y español)",
      "Asistencia de reubicación para compradores nacionales e internacionales",
    ],
    keywords: [
      "Miami real estate",
      "Miami homes for sale",
      "Miami luxury condos",
      "Brickell condos",
      "Miami waterfront homes",
      "Miami investment properties",
    ],
    metaDescription:
      "Explore Miami, FL real estate with PinPoint Realty. Browse luxury condos, waterfront homes & investment properties. Bilingual agents serving Brickell, Coconut Grove & all Miami neighborhoods.",
    metaDescription_es:
      "Explore bienes raíces en Miami, FL con PinPoint Realty. Vea condominios de lujo, casas frente al mar y propiedades de inversión. Agentes bilingüos en Brickell, Coconut Grove y Miami.",
  },
  {
    slug: "fort-lauderdale",
    name: "Fort Lauderdale",
    state: "Florida",
    county: "Broward County",
    description:
      "Fort Lauderdale, known as the 'Venice of America' for its expansive canal system, is a premier destination for waterfront living. With over 23 miles of pristine beaches, a revitalized downtown arts and entertainment district, and easy access to Port Everglades and Fort Lauderdale-Hollywood International Airport, the city attracts buyers seeking a sophisticated yet relaxed coastal lifestyle.",
    description_es:
      "Fort Lauderdale, conocida como la 'Venecia de América' por su extenso sistema de canales, es un destino principal para la vida frente al mar. Con más de 37 kilómetros de playas vírgenes, un distrito revitalizado de arte y entretenimiento en el centro de la ciudad, y fácil acceso a Port Everglades y al Aeropuerto Internacional Fort Lauderdale-Hollywood, la ciudad atrae a compradores que buscan un estilo de vida costero sofisticado pero relajado.",
    highlights: [
      "300+ miles of navigable inland waterways",
      "Las Olas Boulevard — premier shopping, dining & galleries",
      "Proximity to major cruise port and international airport",
      "Rapidly growing tech and finance employment sectors",
    ],
    highlights_es: [
      "Más de 480 km de vías fluviales navegables en el interior",
      "Las Olas Boulevard — tiendas, restaurantes y galerías de primer nivel",
      "Proximidad a un importante puerto de cruceros y aeropuerto internacional",
      "Sectores de empleo en tecnología y finanzas en rápido crecimiento",
    ],
    services: [
      "Waterfront and intracoastal property sales",
      "Luxury beach condo representation",
      "Yacht-accessible estate brokerage",
      "Competitive market analysis for Broward County",
      "Bilingual real estate services (English & Spanish)",
      "First-time homebuyer guidance and financing referrals",
    ],
    services_es: [
      "Venta de propiedades frente al mar y en la zona intercostera",
      "Representación en condominios de lujo en la playa",
      "Corretaje de propiedades con acceso para yates",
      "Análisis competitivo de mercado para el Condado de Broward",
      "Servicios inmobiliarios bilingües (inglés y español)",
      "Asesoramiento para compradores de primera vivienda y referidos de financiación",
    ],
    keywords: [
      "Fort Lauderdale real estate",
      "Fort Lauderdale homes for sale",
      "Fort Lauderdale waterfront homes",
      "Las Olas real estate",
      "Fort Lauderdale condos",
      "Broward County homes",
    ],
    metaDescription:
      "Find Fort Lauderdale, FL homes & condos with PinPoint Realty. Waterfront properties, Las Olas living & intracoastal estates. Expert agents in Broward County real estate.",
    metaDescription_es:
      "Encuentra casas y condominios en Fort Lauderdale, FL con PinPoint Realty. Propiedades frente al mar, vida en Las Olas y fincas intercosteras. Agentes expertos en bienes raíces del Condado de Broward.",
  },
  {
    slug: "boca-raton",
    name: "Boca Raton",
    state: "Florida",
    county: "Palm Beach County",
    description:
      "Boca Raton is an upscale coastal city renowned for its world-class golf courses, top-rated schools, and elegant Mediterranean-inspired architecture. Located in southern Palm Beach County, Boca offers a blend of resort-style amenities and family-friendly neighborhoods, making it one of South Florida's most desirable communities for luxury homebuyers.",
    description_es:
      "Boca Raton es una ciudad costera de lujo reconocida por sus campos de golf de clase mundial, escuelas de primer nivel y elegante arquitectura de inspiración mediterránea. Ubicada en el sur del condado de Palm Beach, Boca ofrece una combinación de comodidades estilo resort y vecindarios familiares, lo que la convierte en una de las comunidades más deseables del sur de Florida para compradores de viviendas de lujo.",
    highlights: [
      "Home to the Boca Raton Resort & Club and Royal Palm Yacht & Country Club",
      "Top-ranked public and private schools",
      "Beautiful beaches with lifeguard-protected parks",
      "Vibrant Mizner Park shopping and cultural district",
    ],
    highlights_es: [
      "Hogar del Boca Raton Resort & Club y el Royal Palm Yacht & Country Club",
      "Escuelas públicas y privadas de primer nivel",
      "Hermosas playas con parques protegidos por salvavidas",
      "Vibrante distrito comercial y cultural de Mizner Park",
    ],
    services: [
      "Luxury home sales in gated golf communities",
      "Oceanfront and beach condo brokerage",
      "Country club and resort-style community representation",
      "Competitive market analysis for Palm Beach County",
      "Bilingual real estate services (English & Spanish)",
      "Relocation assistance for families",
    ],
    services_es: [
      "Venta de casas de lujo en comunidades de golf privadas",
      "Intermediación de condominios frente al mar y en la playa",
      "Representación en clubes de campo y comunidades estilo resort",
      "Análisis de mercado competitivo para el condado de Palm Beach",
      "Servicios inmobiliarios bilingües (inglés y español)",
      "Asistencia de reubicación para familias",
    ],
    keywords: [
      "Boca Raton real estate",
      "Boca Raton homes for sale",
      "Boca Raton luxury homes",
      "Boca Raton condos",
      "Boca Raton golf communities",
      "Palm Beach County real estate",
    ],
    metaDescription:
      "Discover Boca Raton, FL real estate with PinPoint Realty. Luxury homes, golf communities, oceanfront condos & family neighborhoods in Palm Beach County.",
    metaDescription_es:
      "Descubra bienes raíces en Boca Raton, FL con PinPoint Realty. Casas de lujo, comunidades de golf, condominios frente al mar y vecindarios familiares en el condado de Palm Beach.",
  },
  {
    slug: "west-palm-beach",
    name: "West Palm Beach",
    state: "Florida",
    county: "Palm Beach County",
    description:
      "West Palm Beach is the cultural and economic heart of Palm Beach County. With its thriving downtown Clematis Street district, the Norton Museum of Art, and proximity to Palm Beach Island, the city offers an exciting urban lifestyle paired with easy access to beaches and outdoor recreation. The real estate market ranges from historic neighborhoods to modern waterfront towers.",
    description_es:
      "West Palm Beach es el corazón cultural y económico del Condado de Palm Beach. Con su vibrante distrito de Clematis Street, el Museo de Arte Norton y su proximidad a Palm Beach Island, la ciudad ofrece un emocionante estilo de vida urbano complementado con fácil acceso a playas y recreación al aire libre. El mercado inmobiliario abarca desde vecindarios históricos hasta modernas torres frente al mar.",
    highlights: [
      "Downtown Clematis Street and CityPlace entertainment districts",
      "Norton Museum of Art and Kravis Center for the Performing Arts",
      "Minutes from Palm Beach Island's world-famous Worth Avenue",
      "Growing tech and healthcare employment sectors",
    ],
    highlights_es: [
      "Distritos de entretenimiento de Clematis Street y CityPlace en el centro",
      "Museo de Arte Norton y Kravis Center for the Performing Arts",
      "A minutos de la mundialmente famosa Worth Avenue en Palm Beach Island",
      "Sectores de empleo en tecnología y salud en crecimiento",
    ],
    services: [
      "Downtown condo and townhouse sales",
      "Waterfront property brokerage on the Intracoastal",
      "Historic neighborhood home representation",
      "Investment property analysis and management referrals",
      "Bilingual real estate services (English & Spanish)",
      "Competitive market analysis for Palm Beach County",
    ],
    services_es: [
      "Venta de condominios y casas adosadas en el centro",
      "Intermediación de propiedades frente al mar en el Intracoastal",
      "Representación en la compra/venta de viviendas en vecindarios históricos",
      "Análisis de propiedades de inversión y referencias de gestión",
      "Servicios inmobiliarios bilingües (inglés y español)",
      "Análisis de mercado competitivo para el Condado de Palm Beach",
    ],
    keywords: [
      "West Palm Beach real estate",
      "West Palm Beach homes for sale",
      "West Palm Beach condos",
      "West Palm Beach waterfront",
      "Palm Beach County homes",
      "Downtown West Palm Beach",
    ],
    metaDescription:
      "Browse West Palm Beach, FL real estate with PinPoint Realty. Downtown condos, waterfront properties & family homes in Palm Beach County. Expert bilingual agents.",
    metaDescription_es:
      "Explore bienes raíces en West Palm Beach, FL con PinPoint Realty. Condominios en el centro, propiedades frente al mar y casas familiares en Palm Beach County. Agentes bilingües expertos.",
  },
  {
    slug: "hollywood",
    name: "Hollywood",
    state: "Florida",
    county: "Broward County",
    description:
      "Hollywood, Florida blends beach-town charm with urban convenience. Its iconic Hollywood Beach Broadwalk — a 2.5-mile oceanfront promenade — is one of the best in the state. The city offers diverse neighborhoods from the beachside high-rises of Hollywood Beach to the historic charm of Downtown Hollywood, with competitive pricing compared to neighboring Miami and Fort Lauderdale.",
    description_es:
      "Hollywood, Florida, fusiona el encanto de una ciudad costera con la conveniencia urbana. Su icónico Hollywood Beach Broadwalk, un paseo marítimo de 4 kilómetros frente al océano, es uno de los mejores del estado. La ciudad ofrece diversos vecindarios, desde los rascacielos frente a la playa de Hollywood Beach hasta el encanto histórico de Downtown Hollywood, con precios competitivos en comparación con las vecinas Miami y Fort Lauderdale.",
    highlights: [
      "Award-winning Hollywood Beach Broadwalk",
      "Historic Downtown Hollywood arts and dining district",
      "Affordable alternative to Miami and Fort Lauderdale",
      "Seminole Hard Rock Hotel & Casino entertainment complex",
    ],
    highlights_es: [
      "Galardonado Hollywood Beach Broadwalk",
      "Distrito de arte y gastronomía histórico de Downtown Hollywood",
      "Alternativa más asequible a Miami y Fort Lauderdale",
      "Complejo de entretenimiento Seminole Hard Rock Hotel & Casino",
    ],
    services: [
      "Beach condo and oceanfront property sales",
      "Single-family home brokerage in Hollywood Hills & Lakes",
      "Investment property analysis for rental income",
      "First-time homebuyer programs and guidance",
      "Bilingual real estate services (English & Spanish)",
      "Competitive market analysis for Broward County",
    ],
    services_es: [
      "Venta de condominios en la playa y propiedades frente al mar",
      "Corretaje de casas unifamiliares en Hollywood Hills & Lakes",
      "Análisis de propiedades de inversión para ingresos por alquiler",
      "Programas y orientación para compradores de vivienda por primera vez",
      "Servicios inmobiliarios bilingües (inglés y español)",
      "Análisis de mercado competitivo para el Condado de Broward",
    ],
    keywords: [
      "Hollywood FL real estate",
      "Hollywood Florida homes for sale",
      "Hollywood Beach condos",
      "Hollywood FL waterfront",
      "Broward County homes",
    ],
    metaDescription:
      "Explore Hollywood, FL real estate with PinPoint Realty. Beach condos, family homes & investment properties along the Broadwalk. Bilingual agents in Broward County.",
    metaDescription_es:
      "Explore bienes raíces en Hollywood, FL con PinPoint Realty. Condominios en la playa, casas familiares y propiedades de inversión. Agentes bilingües en Broward County.",
  },
  {
    slug: "pompano-beach",
    name: "Pompano Beach",
    state: "Florida",
    county: "Broward County",
    description:
      "Pompano Beach is experiencing a remarkable renaissance, with new oceanfront developments, a revitalized pier, and a growing dining scene transforming this Broward County gem. Known for its excellent fishing, diving, and boating, Pompano Beach offers a more laid-back coastal lifestyle with increasing property values and exciting investment opportunities.",
    description_es:
      "Pompano Beach está experimentando un notable renacimiento, con nuevos desarrollos frente al mar, un muelle revitalizado y una creciente escena gastronómica que están transformando esta joya del condado de Broward. Conocida por su excelente pesca, buceo y navegación, Pompano Beach ofrece un estilo de vida costero más relajado con valores de propiedad en aumento y emocionantes oportunidades de inversión.",
    highlights: [
      "Newly renovated Fisher Family Pier and beach amenities",
      "World-class deep-sea fishing and scuba diving",
      "New luxury oceanfront developments reshaping the skyline",
      "Convenient location between Fort Lauderdale and Boca Raton",
    ],
    highlights_es: [
      "Muelle Fisher Family y servicios de playa recién renovados",
      "Pesca de altura y buceo de clase mundial",
      "Nuevos desarrollos de lujo frente al mar que redefinen el horizonte",
      "Ubicación conveniente entre Fort Lauderdale y Boca Raton",
    ],
    services: [
      "New construction oceanfront condo sales",
      "Waterfront and canal-front home brokerage",
      "Investment property analysis for emerging market",
      "Competitive market analysis for Broward County",
      "Bilingual real estate services (English & Spanish)",
      "Buyer representation for off-market opportunities",
    ],
    services_es: [
      "Venta de condominios de obra nueva frente al mar",
      "Corretaje de viviendas frente al mar y canales",
      "Análisis de propiedades de inversión para mercados emergentes",
      "Análisis de mercado competitivo para el condado de Broward",
      "Servicios inmobiliarios bilingües (inglés y español)",
      "Representación del comprador para oportunidades fuera del mercado",
    ],
    keywords: [
      "Pompano Beach real estate",
      "Pompano Beach homes for sale",
      "Pompano Beach condos",
      "Pompano Beach waterfront",
      "Broward County real estate",
    ],
    metaDescription:
      "Find Pompano Beach, FL homes & condos with PinPoint Realty. New oceanfront developments, waterfront homes & investment properties in Broward County.",
    metaDescription_es:
      "Encuentre casas y condominios en Pompano Beach, FL con PinPoint Realty. Nuevos desarrollos frente al mar, casas y propiedades de inversión en Broward County.",
  },
  {
    slug: "delray-beach",
    name: "Delray Beach",
    state: "Florida",
    county: "Palm Beach County",
    description:
      "Delray Beach, dubbed 'Florida's Village by the Sea,' is celebrated for its award-winning Atlantic Avenue downtown, vibrant arts scene, and pristine municipal beach. This walkable, culturally rich city has become one of South Florida's most desirable locations, attracting young professionals, families, and retirees drawn to its unique blend of small-town charm and upscale amenities.",
    description_es:
      "Delray Beach, apodada 'La Aldea de Florida junto al Mar', es celebrada por su galardonada Atlantic Avenue en el centro, su vibrante escena artística y su inmaculada playa municipal. Esta ciudad transitable y culturalmente rica se ha convertido en uno de los lugares más deseados del sur de Florida, atrayendo a jóvenes profesionales, familias y jubilados por su mezcla única de encanto de pueblo pequeño y comodidades de lujo.",
    highlights: [
      "Award-winning Atlantic Avenue dining and shopping",
      "Morikami Museum and Japanese Gardens",
      "Named 'Most Fun Small Town in America' by USA Today",
      "Thriving art galleries and cultural festivals year-round",
    ],
    highlights_es: [
      "Comercios y restaurantes galardonados en Atlantic Avenue",
      "Museo Morikami y Jardines Japoneses",
      "Nombrada 'La Ciudad Pequeña Más Divertida de América' por USA Today",
      "Prósperas galerías de arte y festivales culturales todo el año",
    ],
    services: [
      "Downtown and Atlantic Avenue area property sales",
      "Beach and oceanfront condo brokerage",
      "Luxury estate representation in gated communities",
      "Competitive market analysis for Palm Beach County",
      "Bilingual real estate services (English & Spanish)",
      "Seasonal and vacation home purchasing assistance",
    ],
    services_es: [
      "Venta de propiedades en el centro y área de Atlantic Avenue",
      "Corretaje de condominios en la playa y frente al mar",
      "Representación de propiedades de lujo en comunidades cerradas",
      "Análisis de mercado competitivo para el Condado de Palm Beach",
      "Servicios inmobiliarios bilingües (inglés y español)",
      "Asistencia en la compra de casas para temporadas y vacaciones",
    ],
    keywords: [
      "Delray Beach real estate",
      "Delray Beach homes for sale",
      "Delray Beach condos",
      "Atlantic Avenue Delray Beach",
      "Palm Beach County homes",
    ],
    metaDescription:
      "Discover Delray Beach, FL real estate with PinPoint Realty. Atlantic Avenue living, beach condos & luxury homes in Palm Beach County. Expert bilingual agents.",
    metaDescription_es:
      "Descubra bienes raíces en Delray Beach, FL con PinPoint Realty. Vida en Atlantic Avenue, condominios de playa y casas de lujo en Palm Beach County. Agentes bilingües expertos.",
  },
  {
    slug: "coral-gables",
    name: "Coral Gables",
    state: "Florida",
    county: "Miami-Dade County",
    description:
      "Coral Gables, known as 'The City Beautiful,' is an elegant, tree-lined community famous for its Mediterranean Revival architecture, the historic Biltmore Hotel, and the iconic Venetian Pool. Home to the University of Miami and a thriving international business corridor, Coral Gables offers some of the finest luxury real estate in South Florida with impeccable neighborhoods and top-rated schools.",
    description_es:
      "Coral Gables, conocida como 'The City Beautiful', es una comunidad elegante y arbolada famosa por su arquitectura estilo Mediterráneo Renacentista, el histórico Biltmore Hotel y la icónica Venetian Pool. Hogar de la Universidad de Miami y de un próspero corredor de negocios internacionales, Coral Gables ofrece algunas de las propiedades de lujo más selectas del sur de Florida, con vecindarios impecables y escuelas de primer nivel.",
    highlights: [
      "Historic Biltmore Hotel and Venetian Pool landmarks",
      "Miracle Mile and Shops at Merrick Park upscale retail",
      "Home to University of Miami and major consulates",
      "Strict architectural standards preserving neighborhood beauty",
    ],
    highlights_es: [
      "Lugares emblemáticos: el histórico Biltmore Hotel y Venetian Pool",
      "Comercio de lujo en Miracle Mile y Shops at Merrick Park",
      "Hogar de la Universidad de Miami y de importantes consulados",
      "Estrictos estándares arquitectónicos que preservan la belleza del vecindario",
    ],
    services: [
      "Luxury estate sales in gated Coral Gables neighborhoods",
      "Historic home brokerage and renovation guidance",
      "International buyer representation",
      "Competitive market analysis for Miami-Dade County",
      "Bilingual real estate services (English & Spanish)",
      "Relocation assistance for executives and professionals",
    ],
    services_es: [
      "Venta de propiedades de lujo en vecindarios privados de Coral Gables",
      "Intermediación de casas históricas y orientación para renovaciones",
      "Representación de compradores internacionales",
      "Análisis competitivo de mercado para el Condado de Miami-Dade",
      "Servicios inmobiliarios bilingües (inglés y español)",
      "Asistencia de reubicación para ejecutivos y profesionales",
    ],
    keywords: [
      "Coral Gables real estate",
      "Coral Gables homes for sale",
      "Coral Gables luxury homes",
      "Coral Gables estates",
      "Miami-Dade County real estate",
    ],
    metaDescription:
      "Browse Coral Gables, FL luxury real estate with PinPoint Realty. Historic estates, Mediterranean homes & upscale living in 'The City Beautiful.' Bilingual agents.",
    metaDescription_es:
      "Explore propiedades de lujo en Coral Gables, FL con PinPoint Realty. Mansiones históricas, casas mediterráneas y vida de lujo en 'The City Beautiful'. Agentes bilingües.",
  },
  {
    slug: "aventura",
    name: "Aventura",
    state: "Florida",
    county: "Miami-Dade County",
    description:
      "Aventura is a modern, master-planned city in northeast Miami-Dade County, best known for the Aventura Mall — one of the largest shopping destinations in the United States. The city features stunning high-rise condominiums with bay and ocean views, excellent charter schools, and a strong sense of community. Its strategic location offers easy access to both Miami and Fort Lauderdale.",
    description_es:
      "Aventura es una ciudad moderna y planificada en el noreste del condado de Miami-Dade, conocida principalmente por el Aventura Mall, uno de los destinos de compras más grandes de Estados Unidos. La ciudad cuenta con impresionantes condominios de gran altura con vistas a la bahía y al océano, excelentes escuelas chárter y un fuerte sentido de comunidad. Su ubicación estratégica ofrece fácil acceso tanto a Miami como a Fort Lauderdale.",
    highlights: [
      "Aventura Mall — one of the top shopping destinations in the U.S.",
      "Modern luxury high-rise condos with panoramic views",
      "Aventura Arts & Cultural Center",
      "Top-rated charter schools and family-friendly environment",
    ],
    highlights_es: [
      "Aventura Mall: uno de los principales destinos de compras en EE. UU.",
      "Modernos condominios de lujo en edificios altos con vistas panorámicas",
      "Aventura Arts & Cultural Center",
      "Escuelas chárter de primer nivel y ambiente familiar",
    ],
    services: [
      "Luxury high-rise condo sales with bay and ocean views",
      "Turnkey and furnished condo representation",
      "Investment property analysis for rental market",
      "Competitive market analysis for northeast Miami-Dade",
      "Bilingual real estate services (English & Spanish)",
      "International buyer and investor guidance",
    ],
    services_es: [
      "Venta de condominios de lujo en edificios altos con vistas a la bahía y al océano",
      "Representación de condominios llave en mano y amueblados",
      "Análisis de propiedades de inversión para el mercado de alquiler",
      "Análisis de mercado competitivo para el noreste de Miami-Dade",
      "Servicios inmobiliarios bilingües (inglés y español)",
      "Asesoramiento para compradores e inversores internacionales",
    ],
    keywords: [
      "Aventura real estate",
      "Aventura condos for sale",
      "Aventura luxury condos",
      "Aventura FL homes",
      "Miami-Dade County condos",
    ],
    metaDescription:
      "Explore Aventura, FL condos & homes with PinPoint Realty. Luxury high-rises, bay views & premier shopping. Expert bilingual agents in Miami-Dade County.",
    metaDescription_es:
      "Explore condominios y casas en Aventura, FL con PinPoint Realty. Lujosos rascacielos, vistas a la bahía y tiendas de primer nivel. Agentes expertos bilingües en Miami-Dade.",
  },
  {
    slug: "sunny-isles-beach",
    name: "Sunny Isles Beach",
    state: "Florida",
    county: "Miami-Dade County",
    description:
      "Sunny Isles Beach, often called the 'Riviera of Florida,' is a barrier island city renowned for its ultra-luxury oceanfront condominium towers by world-famous architects and developers including Porsche Design, Armani Casa, and Turnberry. The city attracts an international clientele seeking premium beachfront living with five-star amenities.",
    description_es:
      "Sunny Isles Beach, a menudo denominada la 'Riviera de Florida', es una ciudad en una isla barrera reconocida por sus torres de condominios de ultra lujo frente al mar, diseñadas por arquitectos y desarrolladores de fama mundial como Porsche Design, Armani Casa y Turnberry. La ciudad atrae a una clientela internacional que busca una vida de playa de primera categoría con amenidades cinco estrellas.",
    highlights: [
      "Ultra-luxury branded residences (Porsche Design Tower, Armani Casa)",
      "Pristine beaches with crystal-clear Atlantic waters",
      "International dining and cultural diversity",
      "Proximity to Bal Harbour Shops and Aventura Mall",
    ],
    highlights_es: [
      "Residencias de ultra lujo de marca (Porsche Design Tower, Armani Casa)",
      "Playas vírgenes con aguas atlánticas cristalinas",
      "Diversidad cultural y gastronómica internacional",
      "Cercanía a Bal Harbour Shops y Aventura Mall",
    ],
    services: [
      "Ultra-luxury oceanfront condo sales",
      "Branded residence and new development representation",
      "International buyer services with multilingual support",
      "Investment and rental property analysis",
      "Bilingual real estate services (English & Spanish)",
      "Pre-construction and off-plan purchase guidance",
    ],
    services_es: [
      "Venta de condominios de ultra lujo frente al mar",
      "Representación en residencias de marca y nuevos desarrollos",
      "Servicios para compradores internacionales con soporte multilingüe",
      "Análisis de propiedades de inversión y alquiler",
      "Servicios inmobiliarios bilingües (inglés y español)",
      "Asesoramiento para compras en preconstrucción y sobre plano",
    ],
    keywords: [
      "Sunny Isles Beach real estate",
      "Sunny Isles Beach condos",
      "Sunny Isles luxury condos",
      "Sunny Isles oceanfront",
      "Miami Beach area real estate",
    ],
    metaDescription:
      "Find Sunny Isles Beach, FL luxury condos with PinPoint Realty. Ultra-luxury oceanfront residences, branded towers & beachfront living. Expert bilingual agents.",
    metaDescription_es:
      "Encuentre condominios de lujo en Sunny Isles Beach, FL con PinPoint Realty. Residencias de ultra lujo frente al mar, torres de marca y vida en la playa. Agentes bilingües expertos.",
  },
  {
    slug: "key-biscayne",
    name: "Key Biscayne",
    state: "Florida",
    county: "Miami-Dade County",
    description:
      "Key Biscayne is an exclusive barrier island community just minutes from downtown Miami, offering a private, resort-like lifestyle surrounded by Crandon Park and Bill Baggs Cape Florida State Park. Known for hosting the Miami Open tennis tournament, the island features luxury single-family homes, upscale condominiums, and some of the most beautiful beaches in Florida.",
    description_es:
      "Key Biscayne es una exclusiva comunidad de isla barrera a solo minutos del centro de Miami, que ofrece un estilo de vida privado y tipo resort rodeado por Crandon Park y Bill Baggs Cape Florida State Park. Conocida por albergar el torneo de tenis Miami Open, la isla cuenta con lujosas casas unifamiliares, condominios de alta gama y algunas de las playas más hermosas de Florida.",
    highlights: [
      "Two spectacular state and county parks with pristine beaches",
      "Former home of the Miami Open tennis tournament",
      "Exclusive island community with low crime and top schools",
      "Minutes from Brickell, Coconut Grove, and downtown Miami",
    ],
    highlights_es: [
      "Dos espectaculares parques estatales y del condado con playas inmaculadas",
      "Antigua sede del torneo de tenis Miami Open",
      "Comunidad isleña exclusiva con baja criminalidad y escuelas de primer nivel",
      "A minutos de Brickell, Coconut Grove y el centro de Miami",
    ],
    services: [
      "Luxury island estate and single-family home sales",
      "Oceanfront and bayfront condo brokerage",
      "Seasonal and vacation property representation",
      "Competitive market analysis for Key Biscayne",
      "Bilingual real estate services (English & Spanish)",
      "Private and off-market listing access",
    ],
    services_es: [
      "Venta de propiedades de lujo en la isla y casas unifamiliares",
      "Corretaje de condominios frente al mar y frente a la bahía",
      "Representación de propiedades de temporada y vacacionales",
      "Análisis de mercado competitivo para Key Biscayne",
      "Servicios inmobiliarios bilingües (inglés y español)",
      "Acceso a listados privados y fuera de mercado",
    ],
    keywords: [
      "Key Biscayne real estate",
      "Key Biscayne homes for sale",
      "Key Biscayne condos",
      "Key Biscayne luxury homes",
      "Miami island real estate",
    ],
    metaDescription:
      "Discover Key Biscayne, FL real estate with PinPoint Realty. Exclusive island homes, oceanfront condos & resort-style living minutes from Miami. Bilingual agents.",
    metaDescription_es:
      "Descubra propiedades en Key Biscayne, FL con PinPoint Realty. Exclusivas casas en la isla, condominios frente al mar y vida tipo resort cerca de Miami. Agentes bilingües.",
  },
  {
    slug: "miami-beach",
    name: "Miami Beach",
    state: "Florida",
    county: "Miami-Dade County",
    description:
      "Miami Beach is a world-famous barrier island city encompassing South Beach, Mid-Beach, and North Beach. From the Art Deco Historic District to the ultra-luxury condos of Faena and Surf Club, Miami Beach offers an unparalleled combination of culture, nightlife, beaches, and real estate. The city is a global destination for investors, celebrities, and lifestyle buyers.",
    description_es:
      "Miami Beach es una ciudad costera de renombre mundial que abarca South Beach, Mid-Beach y North Beach. Desde el Distrito Histórico Art Déco hasta los condominios de ultra lujo de Faena y Surf Club, Miami Beach ofrece una combinación inigualable de cultura, vida nocturna, playas y bienes raíces. La ciudad es un destino global para inversionistas, celebridades y compradores de estilo de vida.",
    highlights: [
      "Iconic Art Deco Historic District and South Beach nightlife",
      "Lincoln Road and Collins Avenue premier shopping",
      "World-renowned restaurants and celebrity chef outposts",
      "Ultra-luxury developments including Faena and Four Seasons Surf Club",
    ],
    highlights_es: [
      "Icónico Distrito Histórico Art Déco y vida nocturna de South Beach",
      "Compras de primer nivel en Lincoln Road y Collins Avenue",
      "Restaurantes de renombre mundial y establecimientos de chefs célebres",
      "Desarrollos de ultra lujo que incluyen Faena y Four Seasons Surf Club",
    ],
    services: [
      "Luxury condo sales in South Beach, Mid-Beach & North Beach",
      "Art Deco and historic property brokerage",
      "Ultra-luxury and penthouse representation",
      "Investment property and short-term rental analysis",
      "Bilingual real estate services (English & Spanish)",
      "International buyer and celebrity client services",
    ],
    services_es: [
      "Venta de condominios de lujo en South Beach, Mid-Beach y North Beach",
      "Intermediación de propiedades históricas y Art Déco",
      "Representación de propiedades de ultra lujo y penthouses",
      "Análisis de propiedades de inversión y alquileres a corto plazo",
      "Servicios inmobiliarios bilingües (inglés y español)",
      "Servicios para compradores internacionales y clientes VIP",
    ],
    keywords: [
      "Miami Beach real estate",
      "Miami Beach condos for sale",
      "South Beach condos",
      "Miami Beach luxury real estate",
      "Miami Beach oceanfront",
    ],
    metaDescription:
      "Browse Miami Beach, FL real estate with PinPoint Realty. South Beach condos, luxury oceanfront penthouses & Art Deco properties. Expert bilingual agents.",
    metaDescription_es:
      "Explore bienes raíces en Miami Beach, FL con PinPoint Realty. Condominios en South Beach, penthouses de lujo frente al mar y propiedades Art Déco. Agentes bilingües expertos.",
  },
  {
    slug: "deerfield-beach",
    name: "Deerfield Beach",
    state: "Florida",
    county: "Broward County",
    description:
      "Deerfield Beach is a charming coastal city at the northern tip of Broward County, known for its Blue Wave–certified beach, historic pier, and family-friendly atmosphere. The city offers a more relaxed pace compared to neighboring Boca Raton and Fort Lauderdale, with competitive home prices and a growing community of restaurants and shops along the waterfront.",
    description_es:
      "Deerfield Beach es una encantadora ciudad costera en el extremo norte del condado de Broward, conocida por su playa certificada Blue Wave, su muelle histórico y su ambiente familiar. La ciudad ofrece un ritmo más relajado en comparación con las vecinas Boca Raton y Fort Lauderdale, con precios de viviendas competitivos y una creciente comunidad de restaurantes y tiendas a lo largo de la costa.",
    highlights: [
      "Blue Wave–certified beach with iconic pier",
      "Quiet Island Park nature preserve",
      "Affordable coastal living in Broward County",
      "Growing culinary and craft brewery scene",
    ],
    highlights_es: [
      "Playa certificada Blue Wave con muelle icónico",
      "Reserva natural Quiet Island Park",
      "Vida costera asequible en el condado de Broward",
      "Creciente escena culinaria y de cervecerías artesanales",
    ],
    services: [
      "Beach and oceanfront condo sales",
      "Single-family home brokerage in east and west Deerfield",
      "First-time homebuyer guidance and financing referrals",
      "Competitive market analysis for Broward County",
      "Bilingual real estate services (English & Spanish)",
      "Investment property and rental income analysis",
    ],
    services_es: [
      "Venta de condominios frente a la playa y al mar",
      "Corretaje de viviendas unifamiliares en el este y oeste de Deerfield",
      "Orientación para compradores de primera vivienda y referencias de financiamiento",
      "Análisis de mercado competitivo para el condado de Broward",
      "Servicios inmobiliarios bilingües (inglés y español)",
      "Análisis de propiedades de inversión y rentas",
    ],
    keywords: [
      "Deerfield Beach real estate",
      "Deerfield Beach homes for sale",
      "Deerfield Beach condos",
      "Deerfield Beach FL",
      "Broward County homes",
    ],
    metaDescription:
      "Find Deerfield Beach, FL homes & condos with PinPoint Realty. Beachfront living, family neighborhoods & coastal charm in Broward County. Bilingual agents.",
    metaDescription_es:
      "Encuentre casas y condominios en Deerfield Beach, FL con PinPoint Realty. Vida frente a la playa, barrios familiares y encanto costero en Broward County. Agentes bilingües.",
  },
  {
    slug: "jupiter",
    name: "Jupiter",
    state: "Florida",
    county: "Palm Beach County",
    description:
      "Jupiter is a picturesque coastal town in northern Palm Beach County, beloved for its natural beauty, the iconic Jupiter Inlet Lighthouse, and its world-class golf courses. Home to spring training for the Miami Marlins and St. Louis Cardinals, Jupiter offers a laid-back luxury lifestyle with pristine beaches, excellent schools, and a strong sense of community.",
    description_es:
      "Jupiter es una pintoresca ciudad costera en el norte del Condado de Palm Beach, apreciada por su belleza natural, el icónico Faro de Jupiter Inlet y sus campos de golf de clase mundial. Sede de los entrenamientos de primavera de los Miami Marlins y los St. Louis Cardinals, Jupiter ofrece un estilo de vida de lujo relajado con playas vírgenes, excelentes escuelas y un fuerte sentido de comunidad.",
    highlights: [
      "Historic Jupiter Inlet Lighthouse and Museum",
      "Roger Dean Chevrolet Stadium — MLB spring training",
      "Jonathan Dickinson State Park and Blowing Rocks Preserve",
      "Top-rated public and private schools",
    ],
    highlights_es: [
      "Faro y Museo histórico de Jupiter Inlet",
      "Estadio Roger Dean Chevrolet — Entrenamientos de primavera de la MLB",
      "Jonathan Dickinson State Park y Blowing Rocks Preserve",
      "Escuelas públicas y privadas mejor calificadas",
    ],
    services: [
      "Luxury waterfront and estate home sales",
      "Golf community and country club representation",
      "Oceanfront and inlet-area condo brokerage",
      "Competitive market analysis for northern Palm Beach County",
      "Bilingual real estate services (English & Spanish)",
      "Family relocation and school district guidance",
    ],
    services_es: [
      "Venta de propiedades de lujo frente al mar y grandes fincas",
      "Representación en comunidades de golf y clubes de campo",
      "Corretaje de condominios frente al mar y en la zona de la ensenada",
      "Análisis de mercado competitivo para el norte del Condado de Palm Beach",
      "Servicios inmobiliarios bilingües (inglés y español)",
      "Orientación para reubicación familiar y distritos escolares",
    ],
    keywords: [
      "Jupiter FL real estate",
      "Jupiter Florida homes for sale",
      "Jupiter waterfront homes",
      "Jupiter golf communities",
      "Palm Beach County real estate",
    ],
    metaDescription:
      "Explore Jupiter, FL real estate with PinPoint Realty. Waterfront estates, golf communities & family homes in northern Palm Beach County. Expert bilingual agents.",
    metaDescription_es:
      "Explore bienes raíces en Jupiter, FL con PinPoint Realty. Casas frente al mar, comunidades de golf y propiedades familiares en el norte de Palm Beach County.",
  },
  {
    slug: "palm-beach",
    name: "Palm Beach",
    state: "Florida",
    county: "Palm Beach County",
    description:
      "Palm Beach is one of the most prestigious and exclusive communities in the United States, synonymous with old-money elegance, world-famous Worth Avenue shopping, and breathtaking oceanfront estates. This barrier island enclave has been home to American royalty, billionaires, and dignitaries for over a century. Real estate in Palm Beach represents the pinnacle of luxury living.",
    description_es:
      "Palm Beach es una de las comunidades más prestigiosas y exclusivas de los Estados Unidos, sinónimo de elegancia clásica, las mundialmente famosas tiendas de Worth Avenue, e impresionantes propiedades frente al mar. Este enclave en la isla ha sido el hogar de la realeza estadounidense, multimillonarios y dignatarios durante más de un siglo. Los bienes raíces en Palm Beach representan la cúspide de la vida de lujo.",
    highlights: [
      "Worth Avenue — world-renowned luxury shopping destination",
      "The Breakers and Mar-a-Lago historic landmarks",
      "Pristine beaches with exclusive oceanfront estates",
      "Flagler Museum and vibrant cultural calendar",
    ],
    highlights_es: [
      "Worth Avenue: destino de compras de lujo reconocido mundialmente",
      "Los lugares históricos The Breakers y Mar-a-Lago",
      "Playas vírgenes con exclusivas propiedades frente al mar",
      "El Museo Flagler y un vibrante calendario cultural",
    ],
    services: [
      "Ultra-luxury oceanfront estate brokerage",
      "Historic mansion and landmark property sales",
      "Private and off-market listing representation",
      "Estate planning and trust-related real estate guidance",
      "Bilingual real estate services (English & Spanish)",
      "Discreet, high-net-worth client services",
    ],
    services_es: [
      "Intermediación de propiedades de ultra lujo frente al mar",
      "Venta de mansiones históricas y propiedades emblemáticas",
      "Representación de listados privados y fuera del mercado",
      "Planificación patrimonial y asesoramiento inmobiliario relacionado con fideicomisos",
      "Servicios inmobiliarios bilingües (inglés y español)",
      "Servicios discretos para clientes de alto patrimonio neto",
    ],
    keywords: [
      "Palm Beach real estate",
      "Palm Beach homes for sale",
      "Palm Beach luxury estates",
      "Palm Beach oceanfront",
      "Worth Avenue Palm Beach",
      "Palm Beach mansions",
    ],
    metaDescription:
      "Discover Palm Beach, FL luxury real estate with PinPoint Realty. Oceanfront estates, Worth Avenue living & ultra-luxury homes. Discreet bilingual representation.",
    metaDescription_es:
      "Descubra bienes raíces de lujo en Palm Beach, FL con PinPoint Realty. Propiedades frente al mar, vida en Worth Avenue y casas de ultra lujo. Representación bilingüe discreta.",
  },
  {
    slug: "hallandale-beach",
    name: "Hallandale Beach",
    state: "Florida",
    county: "Broward County",
    description:
      "Hallandale Beach sits at the southern tip of Broward County, bordering Aventura and offering stunning oceanfront high-rise condominiums with skyline and ocean views. Known for the Gulfstream Park Racing and Casino entertainment complex, Hallandale Beach is a rapidly developing city with modern luxury towers, diverse dining options, and excellent beach access.",
    description_es:
      "Hallandale Beach se encuentra en el extremo sur del condado de Broward, limitando con Aventura y ofreciendo impresionantes condominios de gran altura frente al mar con vistas al horizonte y al océano. Conocida por el complejo de entretenimiento Gulfstream Park Racing and Casino, Hallandale Beach es una ciudad en rápido desarrollo con modernas torres de lujo, diversas opciones gastronómicas y excelente acceso a la playa.",
    highlights: [
      "Gulfstream Park Racing and Casino entertainment complex",
      "Modern luxury oceanfront condo towers",
      "Proximity to Aventura Mall and Bal Harbour Shops",
      "Diverse, international community with vibrant culture",
    ],
    highlights_es: [
      "Complejo de entretenimiento Gulfstream Park Racing and Casino",
      "Modernas torres de condominios de lujo frente al mar",
      "Proximidad a Aventura Mall y Bal Harbour Shops",
      "Comunidad diversa e internacional con una cultura vibrante",
    ],
    services: [
      "Luxury oceanfront condo sales and representation",
      "Investment property and rental income analysis",
      "New development and pre-construction guidance",
      "Competitive market analysis for south Broward County",
      "Bilingual real estate services (English & Spanish)",
      "International buyer representation",
    ],
    services_es: [
      "Venta y representación de condominios de lujo frente al mar",
      "Análisis de propiedades de inversión e ingresos por alquiler",
      "Asesoramiento en desarrollos nuevos y pre-construcción",
      "Análisis de mercado competitivo para el sur del condado de Broward",
      "Servicios inmobiliarios bilingües (inglés y español)",
      "Representación de compradores internacionales",
    ],
    keywords: [
      "Hallandale Beach real estate",
      "Hallandale Beach condos",
      "Hallandale Beach homes for sale",
      "Hallandale Beach oceanfront",
      "south Broward real estate",
    ],
    metaDescription:
      "Browse Hallandale Beach, FL condos & homes with PinPoint Realty. Oceanfront towers, investment properties & modern living in south Broward County. Bilingual agents.",
    metaDescription_es:
      "Explore condominios y casas en Hallandale Beach, FL con PinPoint Realty. Torres frente al mar, propiedades de inversión y vida moderna en el sur de Broward. Agentes bilingües.",
  },
  {
    slug: "bal-harbour",
    name: "Bal Harbour",
    state: "Florida",
    county: "Miami-Dade County",
    description:
      "Bal Harbour is an ultra-exclusive village in northeast Miami-Dade County, world-famous for the Bal Harbour Shops luxury retail destination. This small, affluent community features some of the most prestigious oceanfront condominiums in South Florida, including the St. Regis, Oceana, and Ritz-Carlton residences. Bal Harbour offers refined, quiet elegance steps from the beach.",
    description_es:
      "Bal Harbour es una exclusiva comunidad en el noreste del condado de Miami-Dade, mundialmente famoso por su destino de compras de lujo, Bal Harbour Shops. Esta pequeña y prestigiosa comunidad cuenta con algunos de los condominios frente al mar más lujosos del sur de Florida, incluyendo residencias como St. Regis, Oceana y Ritz-Carlton. Bal Harbour ofrece una elegancia refinada y tranquila a pasos de la playa.",
    highlights: [
      "Bal Harbour Shops — premier luxury retail destination",
      "Ultra-luxury branded residences (St. Regis, Ritz-Carlton)",
      "Pristine, uncrowded beaches with dedicated village access",
      "Exclusive, low-density residential community",
    ],
    highlights_es: [
      "Bal Harbour Shops — el principal destino de compras de lujo",
      "Residencias de ultra-lujo de marca (St. Regis, Ritz-Carlton)",
      "Playas vírgenes y poco concurridas con acceso exclusivo para la comunidad",
      "Comunidad residencial exclusiva y de baja densidad",
    ],
    services: [
      "Ultra-luxury oceanfront condo sales",
      "Branded and five-star residence representation",
      "Discreet, high-net-worth client services",
      "Investment property and seasonal rental analysis",
      "Bilingual real estate services (English & Spanish)",
      "International buyer and investor guidance",
    ],
    services_es: [
      "Venta de condominios de ultra-lujo frente al mar",
      "Representación de residencias de marca y cinco estrellas",
      "Servicios discretos para clientes de alto patrimonio",
      "Análisis de propiedades de inversión y alquileres de temporada",
      "Servicios inmobiliarios bilingües (inglés y español)",
      "Asesoramiento para compradores e inversores internacionales",
    ],
    keywords: [
      "Bal Harbour real estate",
      "Bal Harbour condos for sale",
      "Bal Harbour luxury condos",
      "Bal Harbour oceanfront",
      "Bal Harbour Shops area real estate",
    ],
    metaDescription:
      "Find Bal Harbour, FL luxury condos with PinPoint Realty. Ultra-luxury oceanfront residences near Bal Harbour Shops. Discreet bilingual representation.",
    metaDescription_es:
      "Encuentre condominios de lujo en Bal Harbour, FL con PinPoint Realty. Residencias de ultra-lujo frente al mar cerca de Bal Harbour Shops. Representación bilingüe discreta.",
  },
  {
    slug: "surfside",
    name: "Surfside",
    state: "Florida",
    county: "Miami-Dade County",
    description:
      "Surfside is a quaint, walkable beach town nestled between Miami Beach and Bal Harbour. Despite its small size, Surfside has seen significant luxury development and offers a tight-knit community feel with boutique shops along Harding Avenue, excellent kosher dining options, and direct beach access. The town provides a peaceful retreat while remaining minutes from Miami Beach's energy.",
    description_es:
      "Surfside es una pintoresca y transitable ciudad costera ubicada entre Miami Beach y Bal Harbour. A pesar de su pequeño tamaño, Surfside ha experimentado un significativo desarrollo de lujo y ofrece un ambiente de comunidad unida con boutiques a lo largo de Harding Avenue, excelentes opciones de restaurantes kosher y acceso directo a la playa. La ciudad proporciona un refugio de paz mientras se mantiene a minutos de la energía de Miami Beach.",
    highlights: [
      "Charming, walkable community with small-town atmosphere",
      "Direct beach access with uncrowded shoreline",
      "Boutique shops and restaurants along Harding Avenue",
      "New luxury condo developments and rising property values",
    ],
    highlights_es: [
      "Comunidad encantadora y transitable con ambiente de pueblo pequeño",
      "Acceso directo a la playa con costa poco concurrida",
      "Boutiques y restaurantes a lo largo de Harding Avenue",
      "Nuevos desarrollos de condominios de lujo y valores de propiedad en aumento",
    ],
    services: [
      "Oceanfront condo sales and luxury tower representation",
      "Single-family home brokerage in Surfside neighborhoods",
      "New development and pre-construction guidance",
      "Competitive market analysis for northeast Miami-Dade",
      "Bilingual real estate services (English & Spanish)",
      "Seasonal and vacation home purchasing assistance",
    ],
    services_es: [
      "Venta de condominios frente al mar y representación en torres de lujo",
      "Intermediación de viviendas unifamiliares en los vecindarios de Surfside",
      "Asesoramiento en nuevos desarrollos y pre-construcción",
      "Análisis de mercado competitivo para el noreste de Miami-Dade",
      "Servicios inmobiliarios bilingües (inglés y español)",
      "Asistencia en la compra de casas de temporada y vacaciones",
    ],
    keywords: [
      "Surfside FL real estate",
      "Surfside condos for sale",
      "Surfside homes for sale",
      "Surfside Miami Beach area",
      "northeast Miami-Dade real estate",
    ],
    metaDescription:
      "Discover Surfside, FL real estate with PinPoint Realty. Beachfront condos, charming homes & peaceful coastal living near Miami Beach. Expert bilingual agents.",
    metaDescription_es:
      "Descubra bienes raíces en Surfside, FL con PinPoint Realty. Condominios frente al mar, casas encantadoras y vida costera tranquila cerca de Miami Beach. Agentes bilingües expertos.",
  },
  {
    slug: "hialeah",
    name: "Hialeah",
    state: "Florida",
    county: "Miami-Dade County",
    description:
      "Hialeah is one of the largest cities in Miami-Dade County and a cultural hub with a strong Cuban-American heritage. Known for its affordable housing options, thriving small-business economy, and family-oriented neighborhoods, Hialeah offers excellent value for homebuyers seeking proximity to Miami without the premium price tag. The city features Hialeah Park Racing & Casino, a historic landmark, and convenient access to major highways.",
    description_es:
      "Hialeah es una de las ciudades más grandes de Miami-Dade County y un epicentro cultural con una fuerte herencia cubanoamericana. Conocida por sus opciones de vivienda asequibles, una próspera economía de pequeñas empresas y vecindarios orientados a la familia, Hialeah ofrece un excelente valor para los compradores de vivienda que buscan proximidad a Miami sin el precio elevado. La ciudad cuenta con Hialeah Park Racing & Casino, un hito histórico, y acceso conveniente a las principales autopistas.",
    highlights: [
      "Second-largest city in Miami-Dade County with vibrant culture",
      "Historic Hialeah Park Racing & Casino landmark",
      "Affordable home prices compared to neighboring Miami",
      "Strong Cuban-American cultural heritage and dining scene",
    ],
    highlights_es: [
      "La segunda ciudad más grande de Miami-Dade County con una cultura vibrante",
      "El histórico Hialeah Park Racing & Casino como punto de referencia",
      "Precios de casas asequibles en comparación con las ciudades vecinas de Miami",
      "Fuerte herencia cultural cubanoamericana y escena gastronómica",
    ],
    services: [
      "Single-family home and townhouse sales",
      "Condo and multi-family property brokerage",
      "Investment property and rental income analysis",
      "First-time homebuyer guidance and financing referrals",
      "Bilingual real estate services (English & Spanish)",
      "Competitive market analysis for Miami-Dade County",
    ],
    services_es: [
      "Venta de casas unifamiliares y townhouses",
      "Corretaje de condominios y propiedades multifamiliares",
      "Análisis de propiedades de inversión y rentabilidad por alquiler",
      "Orientación y referidos de financiamiento para compradores de primera vivienda",
      "Servicios inmobiliarios bilingües (inglés y español)",
      "Análisis de mercado competitivo para Miami-Dade County",
    ],
    keywords: [
      "Hialeah real estate",
      "Hialeah homes for sale",
      "Hialeah condos",
      "Hialeah FL properties",
      "Miami-Dade County affordable homes",
    ],
    metaDescription:
      "Find Hialeah, FL homes & condos with PinPoint Realty. Affordable family homes, condos & investment properties in Miami-Dade County. Bilingual agents.",
    metaDescription_es:
      "Encuentre casas y condominios en Hialeah, FL con PinPoint Realty. Viviendas familiares asequibles, condominios y propiedades de inversión en Miami-Dade County. Agentes bilingües.",
  },
  {
    slug: "miramar",
    name: "Miramar",
    state: "Florida",
    county: "Broward County",
    description:
      "Miramar is a fast-growing city in western Broward County, celebrated for its master-planned communities, top-rated schools, and diverse population. With easy access to both Miami and Fort Lauderdale via I-75 and the Florida Turnpike, Miramar offers spacious single-family homes, modern townhouses, and family-friendly amenities including the Miramar Regional Park and Ansin Sports Complex.",
    description_es:
      "Miramar es una ciudad de rápido crecimiento al oeste del condado de Broward, celebrada por sus comunidades planificadas, escuelas de primer nivel y población diversa. Con fácil acceso a Miami y Fort Lauderdale a través de la I-75 y el Florida Turnpike, Miramar ofrece amplias casas unifamiliares, casas adosadas modernas y comodidades para toda la familia, incluyendo el Miramar Regional Park y el Ansin Sports Complex.",
    highlights: [
      "Master-planned communities with resort-style amenities",
      "Top-rated public schools and family-friendly neighborhoods",
      "Miramar Regional Park and Ansin Sports Complex",
      "Strategic location between Miami and Fort Lauderdale",
    ],
    highlights_es: [
      "Comunidades planificadas con amenidades estilo resort",
      "Escuelas públicas de primera categoría y vecindarios familiares",
      "Miramar Regional Park y Ansin Sports Complex",
      "Ubicación estratégica entre Miami y Fort Lauderdale",
    ],
    services: [
      "Single-family home sales in gated communities",
      "Townhouse and villa brokerage",
      "New construction and builder representation",
      "Competitive market analysis for western Broward County",
      "Bilingual real estate services (English & Spanish)",
      "Family relocation and school district guidance",
    ],
    services_es: [
      "Venta de casas unifamiliares en comunidades cerradas",
      "Corretaje de casas adosadas y villas",
      "Representación en obras nuevas y constructores",
      "Análisis de mercado competitivo para el oeste del condado de Broward",
      "Servicios inmobiliarios bilingües (inglés y español)",
      "Reubicación familiar y asesoramiento sobre distritos escolares",
    ],
    keywords: [
      "Miramar FL real estate",
      "Miramar homes for sale",
      "Miramar Florida houses",
      "Miramar gated communities",
      "Broward County family homes",
    ],
    metaDescription:
      "Explore Miramar, FL real estate with PinPoint Realty. Family homes, gated communities & modern townhouses in Broward County. Expert bilingual agents.",
    metaDescription_es:
      "Explore bienes raíces en Miramar, FL con PinPoint Realty. Casas familiares, comunidades cerradas y adosadas modernas en Broward. Agentes bilingües expertos.",
  },
  {
    slug: "key-largo",
    name: "Key Largo",
    state: "Florida",
    county: "Monroe County",
    description:
      "Key Largo, the first island of the Florida Keys, is known as the 'Diving Capital of the World' and gateway to the only living coral reef in the continental United States. This tropical paradise offers unique waterfront properties with direct ocean and bay access, making it a premier destination for boaters, divers, and those seeking an island lifestyle just an hour from Miami.",
    description_es:
      "Key Largo, la primera isla de los Cayos de Florida, es conocida como la 'Capital Mundial del Buceo' y la puerta de entrada al único arrecife de coral vivo en los Estados Unidos continentales. Este paraíso tropical ofrece propiedades únicas frente al mar con acceso directo al océano y la bahía, convirtiéndolo en un destino principal para navegantes, buceadores y aquellos que buscan un estilo de vida isleño a solo una hora de Miami.",
    highlights: [
      "Gateway to the Florida Keys and John Pennekamp Coral Reef State Park",
      "World-class diving, snorkeling, and sport fishing",
      "Direct ocean and bay access from waterfront properties",
      "Laid-back island lifestyle just 60 miles from Miami",
    ],
    highlights_es: [
      "Puerta de entrada a los Cayos de Florida y al Parque Estatal John Pennekamp Coral Reef",
      "Buceo, snorkel y pesca deportiva de clase mundial",
      "Acceso directo al océano y la bahía desde propiedades frente al mar",
      "Estilo de vida isleño relajado a solo 96 kilómetros de Miami",
    ],
    services: [
      "Waterfront estate and canal-front home sales",
      "Vacation and investment property brokerage",
      "Short-term rental income analysis",
      "Boat-accessible property specialist representation",
      "Bilingual real estate services (English & Spanish)",
      "Competitive market analysis for the Upper Keys",
    ],
    services_es: [
      "Venta de propiedades frente al mar y casas con acceso a canales",
      "Corretaje de propiedades vacacionales y de inversión",
      "Análisis de ingresos por alquiler a corto plazo",
      "Representación especializada en propiedades accesibles en barco",
      "Servicios inmobiliarios bilingües (inglés y español)",
      "Análisis de mercado competitivo para los Upper Keys",
    ],
    keywords: [
      "Key Largo real estate",
      "Key Largo homes for sale",
      "Key Largo waterfront homes",
      "Florida Keys real estate",
      "Key Largo investment property",
    ],
    metaDescription:
      "Discover Key Largo, FL real estate with PinPoint Realty. Waterfront homes, canal-front estates & island living in the Florida Keys. Expert bilingual agents.",
    metaDescription_es:
      "Descubra bienes raíces en Key Largo, FL con PinPoint Realty. Casas frente al mar, propiedades con acceso a canales y vida isleña en los Cayos de Florida. Agentes bilingües expertos.",
  },
  {
    slug: "tavernier",
    name: "Tavernier",
    state: "Florida",
    county: "Monroe County",
    description:
      "Tavernier is a charming, tight-knit community in the Upper Florida Keys, offering a quieter alternative to neighboring Key Largo while maintaining easy access to world-class fishing, diving, and boating. With Harry Harris Park providing beach access and community recreation, Tavernier attracts buyers seeking authentic Keys living with a small-town atmosphere and stunning natural surroundings.",
    description_es:
      "Tavernier es una comunidad encantadora y unida en los Upper Florida Keys, que ofrece una alternativa más tranquila al vecino Key Largo, manteniendo un fácil acceso a la pesca, el buceo y la navegación de primera clase. Con Harry Harris Park que ofrece acceso a la playa y recreación comunitaria, Tavernier atrae a compradores que buscan una auténtica vida en los Cayos con un ambiente de pueblo pequeño y un impresionante entorno natural.",
    highlights: [
      "Harry Harris Park with beach, boat ramps, and recreation facilities",
      "Quiet, residential alternative in the Upper Keys",
      "Excellent fishing, diving, and kayaking opportunities",
      "Historic Florida Keys architecture and community charm",
    ],
    highlights_es: [
      "Harry Harris Park con playa, rampas para botes e instalaciones recreativas",
      "Alternativa tranquila y residencial en los Upper Keys",
      "Excelentes oportunidades para pescar, bucear y hacer kayak",
      "Arquitectura histórica de los Cayos de Florida y encanto comunitario",
    ],
    services: [
      "Residential home and lot sales",
      "Waterfront and canal-front property brokerage",
      "Vacant land and new construction representation",
      "Investment and vacation rental property analysis",
      "Bilingual real estate services (English & Spanish)",
      "Competitive market analysis for Monroe County",
    ],
    services_es: [
      "Ventas de casas residenciales y terrenos",
      "Corretaje de propiedades frente al mar y frente al canal",
      "Representación de terrenos baldíos y construcciones nuevas",
      "Análisis de propiedades de inversión y alquiler vacacional",
      "Servicios inmobiliarios bilingües (inglés y español)",
      "Análisis de mercado competitivo para el condado de Monroe",
    ],
    keywords: [
      "Tavernier FL real estate",
      "Tavernier homes for sale",
      "Tavernier Florida Keys",
      "Upper Keys real estate",
      "Monroe County homes",
    ],
    metaDescription:
      "Find Tavernier, FL homes & land with PinPoint Realty. Waterfront properties, vacant lots & Keys living in Monroe County. Expert bilingual agents.",
    metaDescription_es:
      "Encuentre casas y terrenos en Tavernier, FL con PinPoint Realty. Propiedades frente al mar, lotes baldíos y vida en los Cayos del Condado de Monroe. Agentes bilingües expertos.",
  },
  {
    slug: "doral",
    name: "Doral",
    state: "Florida",
    county: "Miami-Dade County",
    description:
      "Doral is one of South Florida's fastest-growing cities, home to the Trump National Doral golf resort and a thriving international business community. With master-planned neighborhoods, top-rated schools, and modern townhomes and single-family residences, Doral attracts families, professionals, and investors looking for newer construction and central access to Miami International Airport.",
    description_es:
      "Doral es una de las ciudades de más rápido crecimiento en el sur de la Florida, hogar del resort de golf Trump National Doral y de una próspera comunidad empresarial internacional. Con vecindarios planificados, escuelas de primer nivel y modernas casas adosadas y residencias unifamiliares, Doral atrae a familias, profesionales e inversionistas que buscan construcciones más nuevas y acceso céntrico al Aeropuerto Internacional de Miami.",
    highlights: [
      "Home to Trump National Doral Miami golf resort",
      "Major business and corporate hub for Latin America",
      "Top-rated charter and public schools",
      "Master-planned communities with modern amenities",
    ],
    highlights_es: [
      "Hogar del resort de golf Trump National Doral Miami",
      "Importante centro empresarial y corporativo para América Latina",
      "Escuelas chárter y públicas de primera categoría",
      "Comunidades planificadas con amenidades modernas",
    ],
    services: [
      "New construction townhome and single-family sales",
      "Gated community and golf course property representation",
      "Investment and rental property analysis",
      "Competitive market analysis for Miami-Dade County",
      "Bilingual real estate services (English & Spanish)",
      "International buyer and corporate relocation services",
    ],
    services_es: [
      "Venta de casas adosadas y unifamiliares de nueva construcción",
      "Representación de propiedades en comunidades cerradas y campos de golf",
      "Análisis de propiedades de inversión y alquiler",
      "Análisis de mercado competitivo para el Condado de Miami-Dade",
      "Servicios inmobiliarios bilingües (inglés y español)",
      "Servicios para compradores internacionales y reubicación corporativa",
    ],
    keywords: [
      "Doral real estate",
      "Doral homes for sale",
      "Doral FL townhomes",
      "Doral luxury homes",
      "Miami-Dade County real estate",
    ],
    metaDescription:
      "Browse Doral, FL real estate with PinPoint Realty. New construction homes, golf communities & gated neighborhoods near Miami International Airport. Bilingual agents.",
    metaDescription_es:
      "Encuentre bienes raíces en Doral, FL con PinPoint Realty. Casas de nueva construcción, comunidades de golf y vecindarios cerrados cerca del Aeropuerto de Miami. Agentes bilingües.",
  },
  {
    slug: "weston",
    name: "Weston",
    state: "Florida",
    county: "Broward County",
    description:
      "Weston is a master-planned, family-oriented city in western Broward County, consistently ranked among the safest and best places to live in Florida. With top-rated schools, beautifully landscaped neighborhoods, and easy access to the Everglades and major highways, Weston is a top choice for families and executives seeking a suburban lifestyle close to Fort Lauderdale and Miami.",
    description_es:
      "Weston es una ciudad planificada, orientada a la familia, ubicada en el oeste del Condado de Broward, constantemente clasificada entre los lugares más seguros y mejores para vivir en Florida. Con escuelas de primera categoría, vecindarios bellamente ajardinados y fácil acceso a los Everglades y las principales autopistas, Weston es una excelente opción para familias y ejecutivos que buscan un estilo de vida suburbano cerca de Fort Lauderdale y Miami.",
    highlights: [
      "Consistently ranked among the safest cities in Florida",
      "A-rated public schools and award-winning private academies",
      "Master-planned community with parks and green spaces",
      "Convenient access to I-75, I-595, and major employment centers",
    ],
    highlights_es: [
      "Constantemente clasificada entre las ciudades más seguras de Florida",
      "Escuelas públicas con calificación A y academias privadas galardonadas",
      "Comunidad maestra planificada con parques y áreas verdes",
      "Acceso conveniente a la I-75, I-595 y a los principales centros de empleo",
    ],
    services: [
      "Single-family and luxury estate home sales",
      "Gated community and golf course property representation",
      "Family relocation and school district guidance",
      "Competitive market analysis for Broward County",
      "Bilingual real estate services (English & Spanish)",
      "Executive and corporate relocation services",
    ],
    services_es: [
      "Venta de casas unifamiliares y propiedades de lujo",
      "Representación en comunidades cerradas y propiedades con campo de golf",
      "Asesoramiento para reubicación familiar y distritos escolares",
      "Análisis de mercado competitivo para el Condado de Broward",
      "Servicios inmobiliarios bilingües (inglés y español)",
      "Servicios de reubicación ejecutiva y corporativa",
    ],
    keywords: [
      "Weston FL real estate",
      "Weston homes for sale",
      "Weston luxury homes",
      "Weston gated communities",
      "Broward County real estate",
    ],
    metaDescription:
      "Discover Weston, FL real estate with PinPoint Realty. Family homes, gated communities & top-rated schools in western Broward County. Expert bilingual agents.",
    metaDescription_es:
      "Descubra bienes raíces en Weston, FL con PinPoint Realty. Casas familiares, comunidades cerradas y escuelas top en el oeste de Broward County. Agentes bilingües expertos.",
  },
  {
    slug: "plantation",
    name: "Plantation",
    state: "Florida",
    county: "Broward County",
    description:
      "Plantation is a centrally located Broward County city offering a balanced mix of established residential neighborhoods, modern shopping at The Fountains and Plantation Walk, and convenient access to Fort Lauderdale and Miami. Known for its tree-lined streets, parks, and strong sense of community, Plantation appeals to families and professionals seeking value and convenience in South Florida.",
    description_es:
      "Plantation es una ciudad con una ubicación céntrica en el condado de Broward que ofrece una mezcla equilibrada de barrios residenciales establecidos, zonas de compras modernas en The Fountains y Plantation Walk, y un acceso conveniente a Fort Lauderdale y Miami. Conocida por sus calles arboladas, parques y un fuerte sentido de comunidad, Plantation atrae a familias y profesionales que buscan valor y conveniencia en el sur de la Florida.",
    highlights: [
      "Centrally located between Fort Lauderdale and the Everglades",
      "Excellent parks, golf courses, and recreation facilities",
      "Diverse housing options from starter homes to luxury estates",
      "Strong local economy and business community",
    ],
    highlights_es: [
      "Ubicación céntrica entre Fort Lauderdale y los Everglades",
      "Excelentes parques, campos de golf e instalaciones recreativas",
      "Diversas opciones de vivienda, desde casas para principiantes hasta propiedades de lujo",
      "Sólida economía local y comunidad empresarial",
    ],
    services: [
      "Single-family home and townhouse sales",
      "Gated community and country club home representation",
      "First-time homebuyer guidance and financing referrals",
      "Competitive market analysis for Broward County",
      "Bilingual real estate services (English & Spanish)",
      "Investment property analysis for the rental market",
    ],
    services_es: [
      "Venta de casas unifamiliares y adosadas (townhouses)",
      "Representación en comunidades cerradas y clubes de campo",
      "Asesoría para compradores de primera vivienda y referencias de financiamiento",
      "Análisis competitivo del mercado para el condado de Broward",
      "Servicios inmobiliarios bilingües (inglés y español)",
      "Análisis de propiedades de inversión para el mercado de alquiler",
    ],
    keywords: [
      "Plantation FL real estate",
      "Plantation homes for sale",
      "Plantation FL homes",
      "Plantation gated communities",
      "Broward County real estate",
    ],
    metaDescription:
      "Find Plantation, FL homes with PinPoint Realty. Family neighborhoods, gated communities & central Broward County living. Expert bilingual agents.",
    metaDescription_es:
      "Encuentre casas en Plantation, FL con PinPoint Realty. Explore barrios familiares y comunidades cerradas en Broward County. Agentes bilingües expertos.",
  },
  {
    slug: "coconut-creek",
    name: "Coconut Creek",
    state: "Florida",
    county: "Broward County",
    description:
      "Coconut Creek, known as the 'Butterfly Capital of the World,' is a charming Broward County city celebrated for its lush landscaping, master-planned neighborhoods, and family-friendly atmosphere. Home to Butterfly World and the Promenade at Coconut Creek, the city offers a balanced lifestyle of nature, shopping, and dining with excellent value compared to coastal markets.",
    description_es:
      "Coconut Creek, conocida como la 'Capital Mundial de las Mariposas', es una encantadora ciudad del condado de Broward célebre por sus exuberantes paisajes, vecindarios planificados y un ambiente familiar. Hogar de Butterfly World y The Promenade at Coconut Creek, la ciudad ofrece un estilo de vida equilibrado de naturaleza, compras y restaurantes con una excelente relación calidad-precio en comparación con los mercados costeros.",
    highlights: [
      "Home to Butterfly World — the world's largest butterfly aviary",
      "Promenade at Coconut Creek shopping and dining destination",
      "Beautifully landscaped, eco-conscious community design",
      "Family-friendly parks, trails, and recreation programs",
    ],
    highlights_es: [
      "Hogar de Butterfly World, el aviario de mariposas más grande del mundo",
      "Promenade at Coconut Creek, destino de compras y restaurantes",
      "Diseño comunitario paisajístico y con conciencia ecológica",
      "Parques, senderos y programas recreativos para toda la familia",
    ],
    services: [
      "Single-family home and townhouse sales",
      "Gated community and 55+ active adult representation",
      "First-time homebuyer guidance and financing referrals",
      "Competitive market analysis for Broward County",
      "Bilingual real estate services (English & Spanish)",
      "Investment property analysis for the rental market",
    ],
    services_es: [
      "Venta de casas unifamiliares y townhouses",
      "Representación en comunidades cerradas y para +55 adultos activos",
      "Orientación para compradores de primera vivienda y referidos de financiación",
      "Análisis de mercado competitivo para el condado de Broward",
      "Servicios inmobiliarios bilingües (inglés y español)",
      "Análisis de propiedades de inversión para el mercado de alquiler",
    ],
    keywords: [
      "Coconut Creek real estate",
      "Coconut Creek homes for sale",
      "Coconut Creek FL homes",
      "Coconut Creek 55+ communities",
      "Broward County real estate",
    ],
    metaDescription:
      "Browse Coconut Creek, FL real estate with PinPoint Realty. Family homes, 55+ communities & landscaped neighborhoods in Broward County. Bilingual agents.",
    metaDescription_es:
      "Explore bienes raíces en Coconut Creek, FL con PinPoint Realty. Casas familiares, comunidades para mayores de 55 años y vecindarios planificados en Broward County. Agentes bilingües.",
  },
  {
    slug: "parkland",
    name: "Parkland",
    state: "Florida",
    county: "Broward County",
    description:
      "Parkland is an upscale, family-focused city in northern Broward County, known for its A-rated schools, equestrian communities, and beautifully maintained gated neighborhoods. With expansive parks, low density, and a strong sense of community, Parkland is one of South Florida's most desirable suburban destinations for families seeking luxury, safety, and top-tier education.",
    description_es:
      "Parkland es una ciudad de alto nivel, enfocada en la familia, ubicada en el norte del condado de Broward, conocida por sus escuelas con calificación A, comunidades ecuestres y vecindarios cerrados bellamente mantenidos. Con parques amplios, baja densidad poblacional y un fuerte sentido de comunidad, Parkland es uno de los destinos suburbanos más deseables del sur de la Florida para familias que buscan lujo, seguridad y educación de primer nivel.",
    highlights: [
      "A-rated public schools and respected private academies",
      "Luxury gated communities and equestrian estates",
      "Award-winning parks and family recreation facilities",
      "Low-density, tree-lined neighborhoods with strong community spirit",
    ],
    highlights_es: [
      "Escuelas públicas con calificación A y respetadas academias privadas",
      "Lujosas comunidades cerradas y fincas ecuestres",
      "Parques galardonados e instalaciones de recreación familiar",
      "Vecindarios de baja densidad, arbolados y con un fuerte espíritu comunitario",
    ],
    services: [
      "Luxury single-family and estate home sales",
      "Gated community and equestrian property representation",
      "Family relocation and school district guidance",
      "Competitive market analysis for Broward County",
      "Bilingual real estate services (English & Spanish)",
      "Executive and corporate relocation services",
    ],
    services_es: [
      "Venta de casas unifamiliares de lujo y propiedades tipo 'estate'",
      "Representación en comunidades cerradas y propiedades ecuestres",
      "Asesoramiento para reubicación familiar y distritos escolares",
      "Análisis de mercado competitivo para el condado de Broward",
      "Servicios de bienes raíces bilingües (inglés y español)",
      "Servicios de reubicación ejecutiva y corporativa",
    ],
    keywords: [
      "Parkland FL real estate",
      "Parkland homes for sale",
      "Parkland luxury homes",
      "Parkland gated communities",
      "Broward County luxury real estate",
    ],
    metaDescription:
      "Discover Parkland, FL real estate with PinPoint Realty. Luxury homes, gated communities & top-rated schools in northern Broward County. Bilingual agents.",
    metaDescription_es:
      "Descubra bienes raíces en Parkland, FL con PinPoint Realty. Casas de lujo, comunidades cerradas y escuelas top en el norte de Broward County. Agentes bilingües.",
  },
  {
    slug: "coral-springs",
    name: "Coral Springs",
    state: "Florida",
    county: "Broward County",
    description:
      "Coral Springs is a master-planned community in northwest Broward County, renowned for its excellent schools, beautiful landscaping, and family-friendly atmosphere. With abundant parks, the Coral Springs Museum of Art, and a thriving sports complex, the city offers a suburban lifestyle with all the amenities families seek while maintaining convenient access to Fort Lauderdale and Boca Raton.",
    description_es:
      "Coral Springs es una comunidad con un diseño urbanístico planificado en el noroeste del condado de Broward, reconocida por sus excelentes escuelas, hermosos paisajes y un ambiente familiar. Con numerosos parques, el Museo de Arte de Coral Springs y un próspero complejo deportivo, la ciudad ofrece un estilo de vida suburbano con todas las comodidades que buscan las familias, manteniendo un acceso conveniente a Fort Lauderdale y Boca Raton.",
    highlights: [
      "Award-winning public schools and top-rated private academies",
      "Coral Springs Center for the Arts and Museum of Art",
      "Abundant parks, sports complexes, and recreation facilities",
      "Beautifully landscaped neighborhoods with strict zoning",
    ],
    highlights_es: [
      "Escuelas públicas galardonadas y academias privadas de primer nivel",
      "Centro de Artes y Museo de Arte de Coral Springs",
      "Abundantes parques, complejos deportivos e instalaciones recreativas",
      "Barrios con hermosos paisajes y estricta zonificación",
    ],
    services: [
      "Single-family home sales in family neighborhoods",
      "Townhouse and villa brokerage",
      "Gated community and golf course property representation",
      "Competitive market analysis for Broward County",
      "Bilingual real estate services (English & Spanish)",
      "Family relocation and school district guidance",
    ],
    services_es: [
      "Venta de casas unifamiliares en barrios familiares",
      "Intermediación de townhouses y villas",
      "Representación en comunidades cerradas y propiedades en campos de golf",
      "Análisis de mercado competitivo para el condado de Broward",
      "Servicios inmobiliarios bilingües (inglés y español)",
      "Reubicación familiar y asesoramiento sobre distritos escolares",
    ],
    keywords: [
      "Coral Springs real estate",
      "Coral Springs homes for sale",
      "Coral Springs FL houses",
      "Coral Springs family homes",
      "Broward County real estate",
    ],
    metaDescription:
      "Find Coral Springs, FL homes with PinPoint Realty. Family neighborhoods, excellent schools & master-planned living in Broward County. Expert bilingual agents.",
    metaDescription_es:
      "Encuentre casas en Coral Springs, FL con PinPoint Realty. Barrios familiares, excelentes escuelas y vida planificada en Broward County. Expertos agentes bilingües.",
  },
  {
    slug: "pembroke-pines",
    name: "Pembroke Pines",
    state: "Florida",
    county: "Broward County",
    description:
      "Pembroke Pines is the second-largest city in Broward County and one of the most sought-after family destinations in South Florida. With top-rated schools, master-planned communities, and the Shops at Pembroke Gardens, the city combines suburban comfort with urban conveniences. Its location provides easy access to Miami, Fort Lauderdale, and the Everglades.",
    description_es:
      "Pembroke Pines es la segunda ciudad más grande del Condado de Broward y uno de los destinos familiares más deseados del sur de la Florida. Con escuelas de primera categoría, comunidades planificadas magistralmente y The Shops at Pembroke Gardens, la ciudad combina la comodidad suburbana con las conveniencias urbanas. Su ubicación ofrece fácil acceso a Miami, Fort Lauderdale y los Everglades.",
    highlights: [
      "Top-rated public and charter schools",
      "Shops at Pembroke Gardens outdoor shopping destination",
      "Master-planned communities with resort-style amenities",
      "Convenient access to I-75 and major highways",
    ],
    highlights_es: [
      "Escuelas públicas y charter de primera categoría",
      "Centro comercial al aire libre The Shops at Pembroke Gardens",
      "Comunidades planificadas magistralmente con amenidades estilo resort",
      "Acceso conveniente a la I-75 y a las principales autopistas",
    ],
    services: [
      "Single-family home sales in master-planned communities",
      "Townhouse and condo brokerage",
      "New construction representation",
      "Competitive market analysis for Broward County",
      "Bilingual real estate services (English & Spanish)",
      "Family relocation services",
    ],
    services_es: [
      "Venta de casas unifamiliares en comunidades planificadas magistralmente",
      "Intermediación de townhouses y condominios",
      "Representación en construcciones nuevas",
      "Análisis de mercado competitivo para el Condado de Broward",
      "Servicios inmobiliarios bilingües (inglés y español)",
      "Servicios de reubicación familiar",
    ],
    keywords: [
      "Pembroke Pines real estate",
      "Pembroke Pines homes for sale",
      "Pembroke Pines FL houses",
      "Pembroke Pines family homes",
      "Broward County real estate",
    ],
    metaDescription:
      "Discover Pembroke Pines, FL real estate with PinPoint Realty. Family homes, top-rated schools & master-planned communities in Broward County. Bilingual agents.",
    metaDescription_es:
      "Descubra bienes raíces en Pembroke Pines, FL con PinPoint Realty. Casas familiares, escuelas de primera y comunidades planeadas en Broward County. Agentes bilingües.",
  },
  {
    slug: "sunrise",
    name: "Sunrise",
    state: "Florida",
    county: "Broward County",
    description:
      "Sunrise is a vibrant city in western Broward County, famous for the Sawgrass Mills Mall, one of the largest outlet shopping destinations in the United States. The city offers diverse housing options, from affordable condos to single-family homes, with excellent access to major highways and proximity to the BB&T Center entertainment venue.",
    description_es:
      "Sunrise es una ciudad vibrante en el oeste del condado de Broward, famosa por el Sawgrass Mills Mall, uno de los destinos de compras outlet más grandes de los Estados Unidos. La ciudad ofrece diversas opciones de vivienda, desde condominios asequibles hasta casas unifamiliares, con excelente acceso a las principales autopistas y proximidad al centro de entretenimiento BB&T Center.",
    highlights: [
      "Sawgrass Mills — one of the largest outlet malls in the U.S.",
      "BB&T Center — premier entertainment and sports venue",
      "Diverse, affordable housing options",
      "Central location with easy highway access",
    ],
    highlights_es: [
      "Sawgrass Mills — uno de los centros comerciales outlet más grandes de EE. UU.",
      "BB&T Center — principal centro de entretenimiento y deportes",
      "Opciones de vivienda diversas y asequibles",
      "Ubicación central con fácil acceso a autopistas",
    ],
    services: [
      "Condo and townhome sales",
      "Single-family home brokerage",
      "Investment property analysis",
      "Competitive market analysis for Broward County",
      "Bilingual real estate services (English & Spanish)",
      "First-time homebuyer guidance",
    ],
    services_es: [
      "Venta de condominios y casas adosadas",
      "Intermediación de casas unifamiliares",
      "Análisis de propiedades de inversión",
      "Análisis de mercado competitivo para el Condado de Broward",
      "Servicios inmobiliarios bilingües (inglés y español)",
      "Asesoramiento para compradores de primera vivienda",
    ],
    keywords: [
      "Sunrise FL real estate",
      "Sunrise homes for sale",
      "Sunrise condos",
      "Sawgrass Mills area homes",
      "Broward County real estate",
    ],
    metaDescription:
      "Browse Sunrise, FL real estate with PinPoint Realty. Condos, townhomes & family homes near Sawgrass Mills in Broward County. Expert bilingual agents.",
    metaDescription_es:
      "Explore bienes raíces en Sunrise, FL con PinPoint Realty. Condominios, casas adosadas y viviendas familiares cerca de Sawgrass Mills en Broward County. Expertos agentes bilingües.",
  },
  {
    slug: "wellington",
    name: "Wellington",
    state: "Florida",
    county: "Palm Beach County",
    description:
      "Wellington is an affluent village in Palm Beach County, internationally recognized as the equestrian capital of the world and home to the Winter Equestrian Festival. The community offers luxury estate homes, top-rated schools, and a unique blend of rural charm and sophisticated amenities, attracting equestrian enthusiasts and families alike.",
    description_es:
      "Wellington es un pueblo próspero en el condado de Palm Beach, reconocido internacionalmente como la capital ecuestre del mundo y sede del Winter Equestrian Festival. La comunidad ofrece casas de lujo, escuelas de primera categoría y una mezcla única de encanto rural y comodidades sofisticadas, atrayendo tanto a entusiastas ecuestres como a familias.",
    highlights: [
      "Winter Equestrian Festival — premier global equestrian event",
      "Equestrian estates and world-class polo facilities",
      "Top-rated schools and family-friendly atmosphere",
      "Village lifestyle with upscale dining and shopping",
    ],
    highlights_es: [
      "Winter Equestrian Festival — el principal evento ecuestre global",
      "Fincas ecuestres e instalaciones de polo de clase mundial",
      "Escuelas de primera categoría y ambiente familiar",
      "Estilo de vida de pueblo con restaurantes y tiendas de lujo",
    ],
    services: [
      "Luxury equestrian estate and farm property sales",
      "Single-family home and villa brokerage",
      "Equestrian facility and land representation",
      "Competitive market analysis for Palm Beach County",
      "Bilingual real estate services (English & Spanish)",
      "Relocation services for equestrian professionals",
    ],
    services_es: [
      "Venta de fincas y propiedades ecuestres de lujo",
      "Corretaje de casas unifamiliares y villas",
      "Representación de instalaciones ecuestres y terrenos",
      "Análisis de mercado competitivo para el condado de Palm Beach",
      "Servicios inmobiliarios bilingües (inglés y español)",
      "Servicios de reubicación para profesionales ecuestres",
    ],
    keywords: [
      "Wellington FL real estate",
      "Wellington homes for sale",
      "Wellington equestrian estates",
      "Wellington Florida polo",
      "Palm Beach County real estate",
    ],
    metaDescription:
      "Explore Wellington, FL real estate with PinPoint Realty. Equestrian estates, luxury homes & family properties in Palm Beach County. Expert bilingual agents.",
    metaDescription_es:
      "Explore bienes raíces en Wellington, FL con PinPoint Realty. Fincas ecuestres, casas de lujo y propiedades familiares en Palm Beach. Agentes expertos y bilingües.",
  },
  {
    slug: "palm-beach-gardens",
    name: "Palm Beach Gardens",
    state: "Florida",
    county: "Palm Beach County",
    description:
      "Palm Beach Gardens is an upscale community in northern Palm Beach County, known as the golf capital of the world with over 20 championship courses. Home to the PGA of America headquarters and the Gardens Mall, this master-planned city offers luxury golf course homes, excellent shopping, and a refined suburban lifestyle.",
    description_es:
      "Palm Beach Gardens es una comunidad de lujo en el norte del condado de Palm Beach, conocida como la capital mundial del golf con más de 20 campos de campeonato. Sede de las oficinas principales de la PGA de América y del Gardens Mall, esta ciudad planificada maestra ofrece lujosas casas en campos de golf, excelentes tiendas y un estilo de vida suburbano refinado.",
    highlights: [
      "PGA headquarters and over 20 championship golf courses",
      "The Gardens Mall — upscale shopping destination",
      "Downtown at the Gardens dining and entertainment",
      "Top-rated schools and family-friendly neighborhoods",
    ],
    highlights_es: [
      "Oficinas principales de la PGA y más de 20 campos de golf de campeonato",
      "The Gardens Mall — destino de compras de lujo",
      "Restaurantes y entretenimiento en Downtown at the Gardens",
      "Escuelas de primer nivel y vecindarios familiares",
    ],
    services: [
      "Luxury golf course home and estate sales",
      "Gated community and country club representation",
      "New construction and builder representation",
      "Competitive market analysis for Palm Beach County",
      "Bilingual real estate services (English & Spanish)",
      "Executive relocation services",
    ],
    services_es: [
      "Venta de casas de lujo en campos de golf y propiedades",
      "Representación en comunidades cerradas y clubes de campo",
      "Representación en construcciones nuevas y para constructores",
      "Análisis de mercado competitivo para el condado de Palm Beach",
      "Servicios inmobiliarios bilingües (inglés y español)",
      "Servicios de reubicación ejecutiva",
    ],
    keywords: [
      "Palm Beach Gardens real estate",
      "Palm Beach Gardens homes for sale",
      "Palm Beach Gardens golf homes",
      "PGA National real estate",
      "Palm Beach County real estate",
    ],
    metaDescription:
      "Find Palm Beach Gardens, FL homes with PinPoint Realty. Golf course estates, luxury homes & family neighborhoods in northern Palm Beach County. Bilingual agents.",
    metaDescription_es:
      "Encuentre casas en Palm Beach Gardens, FL con PinPoint Realty. Propiedades en campos de golf, casas de lujo y vecindarios familiares en el norte del condado de Palm Beach. Agentes bilingües.",
  },
  {
    slug: "boynton-beach",
    name: "Boynton Beach",
    state: "Florida",
    county: "Palm Beach County",
    description:
      "Boynton Beach is a growing coastal city in southern Palm Beach County, offering beautiful beaches, the historic Boynton Beach Inlet, and a revitalized downtown arts district. With more affordable options than neighboring Boca Raton and Delray Beach, Boynton Beach attracts families, retirees, and investors seeking value in a beachside community.",
    description_es:
      "Boynton Beach es una ciudad costera en crecimiento en el sur del Condado de Palm Beach, que ofrece hermosas playas, el histórico Boynton Beach Inlet y un revitalizado distrito artístico en el centro. Con opciones más asequibles que las vecinas Boca Raton y Delray Beach, Boynton Beach atrae a familias, jubilados e inversores que buscan valor en una comunidad junto a la playa.",
    highlights: [
      "Beautiful beaches and historic inlet for boating and fishing",
      "Boynton Beach Arts District and growing cultural scene",
      "More affordable than neighboring coastal cities",
      "Rapid development and new construction opportunities",
    ],
    highlights_es: [
      "Hermosas playas y entrada histórica para paseos en bote y pesca",
      "Distrito artístico de Boynton Beach y creciente escena cultural",
      "Más asequible que las ciudades costeras vecinas",
      "Rápido desarrollo y oportunidades de nueva construcción",
    ],
    services: [
      "Beach condo and oceanfront property sales",
      "Single-family home and townhouse brokerage",
      "New construction and investment property analysis",
      "Competitive market analysis for Palm Beach County",
      "Bilingual real estate services (English & Spanish)",
      "First-time homebuyer and retirement relocation services",
    ],
    services_es: [
      "Venta de condominios en la playa y propiedades frente al mar",
      "Intermediación de casas unifamiliares y townhouses",
      "Análisis de propiedades de nueva construcción e inversión",
      "Análisis competitivo de mercado para el Condado de Palm Beach",
      "Servicios inmobiliarios bilingües (inglés y español)",
      "Servicios para compradores de primera vivienda y reubicación de jubilados",
    ],
    keywords: [
      "Boynton Beach real estate",
      "Boynton Beach homes for sale",
      "Boynton Beach condos",
      "Boynton Beach waterfront",
      "Palm Beach County real estate",
    ],
    metaDescription:
      "Discover Boynton Beach, FL real estate with PinPoint Realty. Beach condos, affordable homes & investment properties in Palm Beach County. Bilingual agents.",
    metaDescription_es:
      "Descubra bienes raíces en Boynton Beach, FL con PinPoint Realty. Condominios, casas asequibles e inversiones en el Condado de Palm Beach. Agentes bilingües.",
  },
  {
    slug: "kendall",
    name: "Kendall",
    state: "Florida",
    county: "Miami-Dade County",
    description:
      "Kendall is a bustling suburban community in southwest Miami-Dade County, centered around Dadeland Mall, one of Miami's premier shopping destinations. With a mix of single-family homes, condos, and townhouses, excellent schools, and convenient access to downtown Miami, Kendall offers urban convenience with suburban comfort.",
    description_es:
      "Kendall es una bulliciosa comunidad suburbana en el suroeste del condado de Miami-Dade, centrada alrededor de Dadeland Mall, uno de los principales destinos de compras de Miami. Con una mezcla de casas unifamiliares, condominios y casas adosadas, excelentes escuelas y acceso conveniente al centro de Miami, Kendall ofrece comodidad urbana con el confort suburbano.",
    highlights: [
      "Dadeland Mall and vibrant shopping districts",
      "Dadeland South and Dadeland North Metrorail stations",
      "Diverse housing options from starter homes to luxury",
      "Excellent restaurants and cultural diversity",
    ],
    highlights_es: [
      "Dadeland Mall y vibrantes distritos de compras",
      "Estaciones de Metrorail Dadeland South y Dadeland North",
      "Diversas opciones de vivienda, desde casas para principiantes hasta de lujo",
      "Excelentes restaurantes y diversidad cultural",
    ],
    services: [
      "Single-family home and townhouse sales",
      "Condo and high-rise brokerage",
      "Investment property analysis",
      "Competitive market analysis for Miami-Dade County",
      "Bilingual real estate services (English & Spanish)",
      "First-time homebuyer guidance",
    ],
    services_es: [
      "Venta de casas unifamiliares y casas adosadas",
      "Corretaje de condominios y rascacielos",
      "Análisis de propiedades de inversión",
      "Análisis de mercado competitivo para el condado de Miami-Dade",
      "Servicios inmobiliarios bilingües (inglés y español)",
      "Asesoramiento para compradores de primera vivienda",
    ],
    keywords: [
      "Kendall real estate",
      "Kendall homes for sale",
      "Kendall condos",
      "Kendall Miami FL",
      "Miami-Dade County real estate",
    ],
    metaDescription:
      "Find Kendall, FL homes & condos with PinPoint Realty. Dadeland area properties, family homes & investment opportunities in Miami-Dade County. Bilingual agents.",
    metaDescription_es:
      "Encuentre casas y condominios en Kendall, FL con PinPoint Realty. Propiedades en el área de Dadeland, casas familiares y oportunidades de inversión en Miami-Dade. Agentes bilingües.",
  },
  {
    slug: "pinecrest",
    name: "Pinecrest",
    state: "Florida",
    county: "Miami-Dade County",
    description:
      "Pinecrest is an affluent village in suburban Miami-Dade County, known for its sprawling estate homes on large lots, top-rated public schools, and beautiful botanical gardens. One of the most desirable family communities in South Florida, Pinecrest offers luxury living with a rural, private atmosphere while remaining minutes from downtown Miami.",
    description_es:
      "Pinecrest es un pueblo de alto nivel socioeconómico en el condado de Miami-Dade, conocido por sus extensas propiedades en grandes terrenos, escuelas públicas de alta calificación y hermosos jardines botánicos. Una de las comunidades familiares más deseables del sur de Florida, Pinecrest ofrece una vida de lujo con una atmósfera rural y privada, mientras se mantiene a minutos del centro de Miami.",
    highlights: [
      "Top-rated Pinecrest public schools",
      "Sprawling estate homes on 1+ acre lots",
      "Pinecrest Gardens — beautiful botanical attraction",
      "Exclusive, low-density luxury community",
    ],
    highlights_es: [
      "Escuelas públicas mejor calificadas de Pinecrest",
      "Extensas propiedades en terrenos de 1+ acre",
      "Pinecrest Gardens — hermosa atracción botánica",
      "Comunidad de lujo exclusiva y de baja densidad",
    ],
    services: [
      "Luxury estate and single-family home sales",
      "Large lot and land acquisition",
      "Family relocation and school district guidance",
      "Competitive market analysis for Miami-Dade County",
      "Bilingual real estate services (English & Spanish)",
      "Private and off-market listing access",
    ],
    services_es: [
      "Venta de propiedades de lujo y viviendas unifamiliares",
      "Adquisición de terrenos grandes y lotes",
      "Asesoramiento para reubicación familiar y distritos escolares",
      "Análisis competitivo del mercado para el condado de Miami-Dade",
      "Servicios inmobiliarios bilingües (inglés y español)",
      "Acceso a listados privados y fuera de mercado",
    ],
    keywords: [
      "Pinecrest real estate",
      "Pinecrest homes for sale",
      "Pinecrest luxury homes",
      "Pinecrest estates",
      "Miami-Dade County luxury real estate",
    ],
    metaDescription:
      "Explore Pinecrest, FL luxury real estate with PinPoint Realty. Estate homes on large lots, top-rated schools & exclusive living in Miami-Dade County. Bilingual agents.",
    metaDescription_es:
      "Explore bienes raíces de lujo en Pinecrest, FL con PinPoint Realty. Propiedades en grandes terrenos, escuelas top y vida exclusiva en Miami-Dade. Agentes bilingües.",
  },
  {
    slug: "south-miami",
    name: "South Miami",
    state: "Florida",
    county: "Miami-Dade County",
    description:
      "South Miami is a charming, walkable city surrounded by Coral Gables and Pinecrest, offering a distinct small-town atmosphere with urban convenience. Known for its pedestrian-friendly downtown on Sunset Drive, diverse dining scene, and the Shops at Sunset Place, South Miami provides an attractive option for those seeking a vibrant community close to top schools.",
    description_es:
      "South Miami es una ciudad encantadora y transitable, rodeada por Coral Gables y Pinecrest, que ofrece una atmósfera distintiva de pueblo pequeño con comodidades urbanas. Conocida por su centro peatonal en Sunset Drive, su diversa oferta gastronómica y las tiendas de Sunset Place, South Miami es una opción atractiva para quienes buscan una comunidad vibrante cerca de las mejores escuelas.",
    highlights: [
      "Walkable downtown with shops and restaurants on Sunset Drive",
      "Shops at Sunset Place outdoor lifestyle center",
      "Top-rated schools and family-friendly neighborhoods",
      "Adjacent to the University of Miami and Coral Gables",
    ],
    highlights_es: [
      "Centro peatonal con tiendas y restaurantes en Sunset Drive",
      "Centro comercial al aire libre Shops at Sunset Place",
      "Escuelas de primer nivel y vecindarios familiares",
      "Adyacente a la Universidad de Miami y Coral Gables",
    ],
    services: [
      "Single-family home and townhome sales",
      "Condo and multi-family property brokerage",
      "Investment property analysis",
      "Competitive market analysis for Miami-Dade County",
      "Bilingual real estate services (English & Spanish)",
      "First-time homebuyer guidance",
    ],
    services_es: [
      "Venta de casas unifamiliares y townhomes",
      "Corretaje de condominios y propiedades multifamiliares",
      "Análisis de propiedades de inversión",
      "Análisis de mercado competitivo para el condado de Miami-Dade",
      "Servicios inmobiliarios bilingües (inglés y español)",
      "Asesoramiento para compradores de primera vivienda",
    ],
    keywords: [
      "South Miami real estate",
      "South Miami homes for sale",
      "South Miami condos",
      "Sunset Drive homes",
      "Miami-Dade County real estate",
    ],
    metaDescription:
      "Browse South Miami, FL real estate with PinPoint Realty. Walkable downtown homes, condos & family properties near Sunset Drive. Expert bilingual agents.",
    metaDescription_es:
      "Explore bienes raíces en South Miami, FL con PinPoint Realty. Casas y condominios céntricos y propiedades familiares cerca de Sunset Drive. Agentes bilingües expertos.",
  },
  {
    slug: "davie",
    name: "Davie",
    state: "Florida",
    county: "Broward County",
    description:
      "Davie is a unique western Broward County town that maintains its rural heritage with equestrian trails, country estates, and a Western-themed downtown. Home to Nova Southeastern University and the Bergeron Rodeo Grounds, Davie offers a diverse real estate market from horse properties to suburban family homes and modern apartments.",
    description_es:
      "Davie es una ciudad única en el oeste del condado de Broward que mantiene su herencia rural con senderos ecuestres, fincas campestres y un centro con temática del Viejo Oeste. Sede de la Universidad Nova Southeastern y del Bergeron Rodeo Grounds, Davie ofrece un mercado inmobiliario diverso que va desde propiedades para caballos hasta casas familiares suburbanas y modernos apartamentos.",
    highlights: [
      "Western-themed heritage with equestrian trails and parks",
      "Nova Southeastern University campus",
      "Diverse housing from country estates to modern apartments",
      "Bergeron Rodeo Grounds and Davie Pro Rodeo",
    ],
    highlights_es: [
      "Herencia temática del Viejo Oeste con senderos y parques ecuestres",
      "Campus de la Universidad Nova Southeastern",
      "Viviendas diversas, desde fincas campestres hasta apartamentos modernos",
      "Bergeron Rodeo Grounds y Davie Pro Rodeo",
    ],
    services: [
      "Equestrian and country estate property sales",
      "Single-family home and townhome brokerage",
      "New construction and student housing investment",
      "Competitive market analysis for Broward County",
      "Bilingual real estate services (English & Spanish)",
      "Family and student relocation services",
    ],
    services_es: [
      "Venta de propiedades ecuestres y fincas campestres",
      "Intermediación de casas unifamiliares y adosadas",
      "Inversión en construcciones nuevas y viviendas para estudiantes",
      "Análisis de mercado competitivo para el condado de Broward",
      "Servicios inmobiliarios bilingües (inglés y español)",
      "Servicios de reubicación familiar y estudiantil",
    ],
    keywords: [
      "Davie FL real estate",
      "Davie homes for sale",
      "Davie horse properties",
      "Davie equestrian estates",
      "Broward County real estate",
    ],
    metaDescription:
      "Find Davie, FL homes with PinPoint Realty. Equestrian estates, country properties & family homes with rural charm in Broward County. Bilingual agents.",
    metaDescription_es:
      "Encuentre casas en Davie, FL con PinPoint Realty. Fincas ecuestres, propiedades campestres y casas familiares con encanto rural en Broward County. Agentes bilingües.",
  },
  {
    slug: "lauderdale-by-the-sea",
    name: "Lauderdale-by-the-Sea",
    state: "Florida",
    county: "Broward County",
    description:
      "Lauderdale-by-the-Sea is a charming beachside town in northern Broward County, known for its laid-back atmosphere, excellent shore diving on the nearby reef, and quaint downtown with shops and restaurants. This walkable, small-town coastal community offers condo living and beachside apartments with a distinctly relaxed Florida vibe.",
    description_es:
      "Lauderdale-by-the-Sea es una encantadora ciudad costera en el norte del Condado de Broward, conocida por su ambiente relajado, excelentes puntos para buceo de costa en el arrecife cercano, y un pintoresco centro con tiendas y restaurantes. Esta comunidad costera transitable y de pueblo pequeño ofrece condominios y apartamentos frente a la playa con una vibración distintivamente relajada de Florida.",
    highlights: [
      "Walkable beach town with pier and diving reef",
      "Excellent shore diving and snorkeling",
      "Quaint downtown with local shops and dining",
      "Relaxed, small-town coastal atmosphere",
    ],
    highlights_es: [
      "Pueblo de playa transitable con muelle y arrecife de buceo",
      "Excelente buceo de costa y snorkel",
      "Pintoresco centro con tiendas y restaurantes locales",
      "Ambiente costero relajado y de pueblo pequeño",
    ],
    services: [
      "Beach condo and oceanfront property sales",
      "Investment and vacation rental property analysis",
      "Short-term rental income optimization",
      "Competitive market analysis for Broward County",
      "Bilingual real estate services (English & Spanish)",
      "Retirement and second-home relocation services",
    ],
    services_es: [
      "Venta de condominios de playa y propiedades frente al mar",
      "Análisis de propiedades de inversión y alquiler vacacional",
      "Optimización de ingresos por alquiler a corto plazo",
      "Análisis de mercado competitivo para el Condado de Broward",
      "Servicios inmobiliarios bilingües (inglés y español)",
      "Servicios de reubicación para jubilación y segundas viviendas",
    ],
    keywords: [
      "Lauderdale-by-the-Sea real estate",
      "Lauderdale-by-the-Sea condos",
      "Lauderdale-by-the-Sea homes",
      "Broward beach condos",
      "Broward County real estate",
    ],
    metaDescription:
      "Discover Lauderdale-by-the-Sea, FL condos with PinPoint Realty. Beachfront living, dive reef access & relaxed coastal lifestyle in Broward County. Bilingual agents.",
    metaDescription_es:
      "Descubra condominios en Lauderdale-by-the-Sea, FL con PinPoint Realty. Viva frente al mar, acceda al arrecife y disfrute el estilo de vida costero en Broward County. Agentes bilingües.",
  },
  {
    slug: "lake-worth",
    name: "Lake Worth",
    state: "Florida",
    county: "Palm Beach County",
    description:
      "Lake Worth is an eclectic, artsy coastal city in Palm Beach County known for its vibrant downtown, historic homes, and the annual Street Painting Festival. With a mix of historic neighborhoods, colorful bungalows, and beachfront condos, Lake Worth offers a bohemian, laid-back alternative to neighboring coastal cities with more affordable options.",
    description_es:
      "Lake Worth es una ciudad costera ecléctica y artística en el condado de Palm Beach, conocida por su vibrante centro, sus casas históricas y el Festival anual de Pintura Callejera. Con una mezcla de vecindarios históricos, bungalows coloridos y condominios frente al mar, Lake Worth ofrece una alternativa bohemia y relajada a las ciudades costeras vecinas, con opciones más asequibles.",
    highlights: [
      "Eclectic, artsy downtown with local galleries and shops",
      "Annual Street Painting Festival and cultural events",
      "Historic neighborhoods with charming bungalows",
      "More affordable beachside living than neighboring cities",
    ],
    highlights_es: [
      "Centro ecléctico y artístico con galerías y tiendas locales",
      "Festival anual de Pintura Callejera y eventos culturales",
      "Barrios históricos con encantadores bungalows",
      "Vida playera más asequible que en ciudades vecinas",
    ],
    services: [
      "Historic home and bungalow sales",
      "Beach condo and coastal property brokerage",
      "Investment and rental property analysis",
      "Competitive market analysis for Palm Beach County",
      "Bilingual real estate services (English & Spanish)",
      "Artist and creative professional relocation services",
    ],
    services_es: [
      "Venta de casas históricas y bungalows",
      "Corretaje de condominios de playa y propiedades costeras",
      "Análisis de propiedades de inversión y alquiler",
      "Análisis de mercado competitivo para el condado de Palm Beach",
      "Servicios inmobiliarios bilingües (inglés y español)",
      "Servicios de reubicación para artistas y profesionales creativos",
    ],
    keywords: [
      "Lake Worth real estate",
      "Lake Worth homes for sale",
      "Lake Worth condos",
      "Lake Worth historic homes",
      "Palm Beach County real estate",
    ],
    metaDescription:
      "Browse Lake Worth, FL real estate with PinPoint Realty. Historic homes, beach condos & eclectic coastal living in Palm Beach County. Expert bilingual agents.",
    metaDescription_es:
      "Explore bienes raíces en Lake Worth, FL con PinPoint Realty. Casas históricas, condominios de playa y vida costera ecléctica en Palm Beach. Agentes bilingües.",
  },
  {
    slug: "north-miami",
    name: "North Miami",
    state: "Florida",
    county: "Miami-Dade County",
    description:
      "North Miami is a diverse, fast-growing city along Biscayne Bay known for its vibrant arts scene, the Museum of Contemporary Art (MOCA), and a mix of mid-century homes, waterfront properties, and modern condos. Its central location offers easy access to Downtown Miami, the airport, and the beaches.",
    description_es:
      "North Miami es una ciudad diversa y en crecimiento a orillas de Biscayne Bay, conocida por su escena artística, el Museo de Arte Contemporáneo (MOCA) y una mezcla de casas mid-century, propiedades frente al mar y condominios modernos. Su ubicación central facilita el acceso al centro de Miami, el aeropuerto y las playas.",
    highlights: [
      "Waterfront access along Biscayne Bay and Keystone Point",
      "Home to MOCA and a thriving arts community",
      "Mid-century architecture and emerging modern developments",
      "Central location near FIU Biscayne Bay Campus",
    ],
    highlights_es: [
      "Acceso costero a Biscayne Bay y Keystone Point",
      "Sede del MOCA y una próspera comunidad artística",
      "Arquitectura mid-century y nuevos desarrollos modernos",
      "Ubicación central cerca del campus FIU Biscayne Bay",
    ],
    services: [
      "Waterfront and Keystone Point home sales",
      "Mid-century renovation property brokerage",
      "Investment and rental property analysis",
      "Bilingual real estate services (English & Spanish)",
      "Relocation assistance for Miami-Dade buyers",
    ],
    services_es: [
      "Venta de casas frente al mar y en Keystone Point",
      "Corretaje de propiedades para renovación mid-century",
      "Análisis de propiedades de inversión y alquiler",
      "Servicios inmobiliarios bilingües (inglés y español)",
      "Asistencia de reubicación para compradores en Miami-Dade",
    ],
    keywords: [
      "North Miami real estate",
      "North Miami homes for sale",
      "Keystone Point homes",
      "North Miami waterfront",
      "Miami-Dade real estate",
    ],
    metaDescription:
      "Browse North Miami, FL real estate with PinPoint Realty. Waterfront homes, Keystone Point properties & mid-century gems in Miami-Dade. Bilingual agents.",
    metaDescription_es:
      "Explore bienes raíces en North Miami, FL con PinPoint Realty. Casas frente al mar, propiedades en Keystone Point y joyas mid-century en Miami-Dade. Agentes bilingües.",
  },
  {
    slug: "north-miami-beach",
    name: "North Miami Beach",
    state: "Florida",
    county: "Miami-Dade County",
    description:
      "North Miami Beach is a culturally rich city offering an excellent mix of affordability and proximity to the ocean. With diverse neighborhoods, the famous Eastern Shores waterfront enclave, and easy access to Aventura, Sunny Isles, and Bal Harbour, it's a strong value play in the Miami-Dade market.",
    description_es:
      "North Miami Beach es una ciudad culturalmente rica que ofrece una excelente combinación de precios accesibles y cercanía al océano. Con vecindarios diversos, el famoso enclave Eastern Shores frente al mar y fácil acceso a Aventura, Sunny Isles y Bal Harbour, es una opción de gran valor en Miami-Dade.",
    highlights: [
      "Eastern Shores waterfront community with deep-water docks",
      "Close to Aventura Mall, Sunny Isles, and Bal Harbour",
      "Diverse, walkable neighborhoods with strong rental demand",
      "Affordable entry point to coastal Miami-Dade",
    ],
    highlights_es: [
      "Comunidad costera Eastern Shores con muelles de aguas profundas",
      "Cerca de Aventura Mall, Sunny Isles y Bal Harbour",
      "Vecindarios diversos y peatonales con fuerte demanda de alquiler",
      "Punto de entrada asequible al Miami-Dade costero",
    ],
    services: [
      "Eastern Shores waterfront home sales",
      "Investment and multi-family property brokerage",
      "Condo sales and 1031 exchange consulting",
      "Bilingual real estate services (English & Spanish)",
      "Buyer representation for first-time and international clients",
    ],
    services_es: [
      "Venta de casas frente al mar en Eastern Shores",
      "Corretaje de propiedades de inversión y multifamiliares",
      "Venta de condominios y asesoría 1031",
      "Servicios inmobiliarios bilingües (inglés y español)",
      "Representación para compradores primerizos e internacionales",
    ],
    keywords: [
      "North Miami Beach real estate",
      "Eastern Shores homes",
      "North Miami Beach condos",
      "NMB waterfront homes",
      "Miami-Dade investment property",
    ],
    metaDescription:
      "Find North Miami Beach, FL homes & condos with PinPoint Realty. Eastern Shores waterfront, investment properties & affordable coastal living. Bilingual agents.",
    metaDescription_es:
      "Encuentre casas y condominios en North Miami Beach, FL con PinPoint Realty. Eastern Shores frente al mar, inversiones y vida costera asequible. Agentes bilingües.",
  },
  {
    slug: "cutler-bay",
    name: "Cutler Bay",
    state: "Florida",
    county: "Miami-Dade County",
    description:
      "Cutler Bay is a peaceful, family-oriented town in southern Miami-Dade known for its tree-lined streets, parks, and proximity to Biscayne National Park. It offers excellent value with single-family homes, gated communities, and easy access to the Keys and Homestead.",
    description_es:
      "Cutler Bay es una tranquila ciudad familiar en el sur de Miami-Dade, conocida por sus calles arboladas, parques y cercanía al Parque Nacional Biscayne. Ofrece excelente valor con casas unifamiliares, comunidades cerradas y fácil acceso a los Cayos y Homestead.",
    highlights: [
      "Family-friendly with parks, trails, and top public schools",
      "Adjacent to Biscayne National Park and Black Point Marina",
      "Strong value for single-family homes in Miami-Dade",
      "Quick access to the Florida Keys via US-1",
    ],
    highlights_es: [
      "Familiar, con parques, senderos y buenas escuelas públicas",
      "Junto al Parque Nacional Biscayne y Black Point Marina",
      "Excelente valor en casas unifamiliares en Miami-Dade",
      "Acceso rápido a los Cayos por US-1",
    ],
    services: [
      "Single-family home sales in gated and open communities",
      "First-time homebuyer representation",
      "Investment and rental property analysis",
      "Bilingual real estate services (English & Spanish)",
      "Relocation assistance for South Miami-Dade families",
    ],
    services_es: [
      "Venta de casas unifamiliares en comunidades cerradas y abiertas",
      "Representación para compradores primerizos",
      "Análisis de propiedades de inversión y alquiler",
      "Servicios inmobiliarios bilingües (inglés y español)",
      "Asistencia de reubicación para familias en el sur de Miami-Dade",
    ],
    keywords: [
      "Cutler Bay real estate",
      "Cutler Bay homes for sale",
      "Cutler Bay gated communities",
      "South Miami-Dade homes",
      "family homes Miami",
    ],
    metaDescription:
      "Discover Cutler Bay, FL real estate with PinPoint Realty. Family homes, gated communities & affordable living near Biscayne National Park. Bilingual agents.",
    metaDescription_es:
      "Descubra bienes raíces en Cutler Bay, FL con PinPoint Realty. Casas familiares, comunidades cerradas y vida asequible cerca del Parque Nacional Biscayne. Agentes bilingües.",
  },
  {
    slug: "homestead",
    name: "Homestead",
    state: "Florida",
    county: "Miami-Dade County",
    description:
      "Homestead is one of the fastest-growing cities in Florida, offering newer construction, agricultural charm, and access to both Everglades and Biscayne National Parks. It's a top market for first-time buyers, investors, and families seeking new homes at attractive prices.",
    description_es:
      "Homestead es una de las ciudades de mayor crecimiento en Florida, con construcción nueva, encanto agrícola y acceso a los parques nacionales Everglades y Biscayne. Es un mercado destacado para compradores primerizos, inversores y familias que buscan casas nuevas a precios atractivos.",
    highlights: [
      "Booming new construction at attractive price points",
      "Gateway to Everglades and Biscayne National Parks",
      "Home to Homestead-Miami Speedway",
      "Strong investment and rental demand",
    ],
    highlights_es: [
      "Auge de construcción nueva a precios atractivos",
      "Puerta de entrada a los parques nacionales Everglades y Biscayne",
      "Sede del Homestead-Miami Speedway",
      "Fuerte demanda de inversión y alquiler",
    ],
    services: [
      "New construction pre-sale representation",
      "First-time homebuyer programs and FHA/VA support",
      "Investment and rental property analysis",
      "Bilingual real estate services (English & Spanish)",
      "Land and agricultural property brokerage",
    ],
    services_es: [
      "Representación en preventa de obra nueva",
      "Programas para compradores primerizos y apoyo FHA/VA",
      "Análisis de propiedades de inversión y alquiler",
      "Servicios inmobiliarios bilingües (inglés y español)",
      "Corretaje de terrenos y propiedades agrícolas",
    ],
    keywords: [
      "Homestead FL real estate",
      "Homestead new construction",
      "Homestead homes for sale",
      "South Miami-Dade investment",
      "Homestead first-time buyer",
    ],
    metaDescription:
      "Browse Homestead, FL real estate with PinPoint Realty. New construction homes, investment properties & first-time buyer options in Miami-Dade. Bilingual agents.",
    metaDescription_es:
      "Explore bienes raíces en Homestead, FL con PinPoint Realty. Casas de obra nueva, propiedades de inversión y opciones para compradores primerizos en Miami-Dade. Agentes bilingües.",
  },
  {
    slug: "palmetto-bay",
    name: "Palmetto Bay",
    state: "Florida",
    county: "Miami-Dade County",
    description:
      "Palmetto Bay is an upscale, village-style community in southern Miami-Dade known as 'The Village of Parks.' With excellent schools, large lots, and a quiet suburban feel close to Coral Gables and Pinecrest, it's a top destination for families seeking estate-style living.",
    description_es:
      "Palmetto Bay es una comunidad exclusiva tipo pueblo en el sur de Miami-Dade, conocida como 'The Village of Parks'. Con excelentes escuelas, lotes grandes y un ambiente suburbano tranquilo cerca de Coral Gables y Pinecrest, es un destino destacado para familias que buscan propiedades tipo estate.",
    highlights: [
      "'Village of Parks' with extensive green space",
      "Top-rated public and private schools",
      "Large lots and estate-style homes",
      "Quiet, family-oriented suburban setting",
    ],
    highlights_es: [
      "'Village of Parks' con amplios espacios verdes",
      "Escuelas públicas y privadas de primer nivel",
      "Lotes grandes y casas tipo estate",
      "Ambiente suburbano tranquilo y familiar",
    ],
    services: [
      "Estate home and large-lot property sales",
      "School-zone-targeted buyer representation",
      "Investment and luxury property analysis",
      "Bilingual real estate services (English & Spanish)",
      "Relocation assistance for families",
    ],
    services_es: [
      "Venta de casas tipo estate y propiedades en lotes grandes",
      "Representación enfocada en zonas escolares destacadas",
      "Análisis de propiedades de inversión y de lujo",
      "Servicios inmobiliarios bilingües (inglés y español)",
      "Asistencia de reubicación para familias",
    ],
    keywords: [
      "Palmetto Bay real estate",
      "Palmetto Bay homes for sale",
      "Palmetto Bay estate homes",
      "South Miami-Dade luxury",
      "Village of Parks homes",
    ],
    metaDescription:
      "Find Palmetto Bay, FL homes with PinPoint Realty. Estate properties, top schools & 'Village of Parks' family living in Miami-Dade. Bilingual agents.",
    metaDescription_es:
      "Encuentre casas en Palmetto Bay, FL con PinPoint Realty. Propiedades tipo estate, mejores escuelas y vida familiar en 'The Village of Parks'. Agentes bilingües.",
  },
  {
    slug: "miami-lakes",
    name: "Miami Lakes",
    state: "Florida",
    county: "Miami-Dade County",
    description:
      "Miami Lakes is a master-planned community known for its 23 lakes, golf course, walkable Main Street, and family-friendly neighborhoods. It blends suburban comfort with thriving local commerce, making it a perennial favorite among Miami-Dade families.",
    description_es:
      "Miami Lakes es una comunidad planificada conocida por sus 23 lagos, su campo de golf, la transitable Main Street y vecindarios familiares. Combina la comodidad suburbana con un comercio local próspero, convirtiéndose en un favorito perenne entre las familias de Miami-Dade.",
    highlights: [
      "Master-planned with 23 lakes and a golf course",
      "Walkable Main Street with shops and restaurants",
      "Excellent schools and family amenities",
      "Strong long-term property value retention",
    ],
    highlights_es: [
      "Comunidad planificada con 23 lagos y campo de golf",
      "Main Street peatonal con tiendas y restaurantes",
      "Excelentes escuelas y comodidades familiares",
      "Sólida retención de valor a largo plazo",
    ],
    services: [
      "Single-family and townhome sales",
      "Lakefront and golf-course property brokerage",
      "Investment and rental property analysis",
      "Bilingual real estate services (English & Spanish)",
      "Relocation assistance for families",
    ],
    services_es: [
      "Venta de casas unifamiliares y townhomes",
      "Corretaje de propiedades frente a lago y campo de golf",
      "Análisis de propiedades de inversión y alquiler",
      "Servicios inmobiliarios bilingües (inglés y español)",
      "Asistencia de reubicación para familias",
    ],
    keywords: [
      "Miami Lakes real estate",
      "Miami Lakes homes for sale",
      "Miami Lakes townhomes",
      "Miami Lakes golf homes",
      "master-planned communities Miami",
    ],
    metaDescription:
      "Discover Miami Lakes, FL real estate with PinPoint Realty. Lakefront homes, golf properties & master-planned family living in Miami-Dade. Bilingual agents.",
    metaDescription_es:
      "Descubra bienes raíces en Miami Lakes, FL con PinPoint Realty. Casas frente al lago, propiedades de golf y vida familiar planificada en Miami-Dade. Agentes bilingües.",
  },
  {
    slug: "miami-shores",
    name: "Miami Shores",
    state: "Florida",
    county: "Miami-Dade County",
    description:
      "Miami Shores is a charming, historic village known for its tree-lined streets, Mediterranean-revival architecture, and tight-knit community. With waterfront homes along Biscayne Bay and the prestigious Miami Shores Country Club, it offers timeless village living near Downtown.",
    description_es:
      "Miami Shores es un pintoresco e histórico pueblo conocido por sus calles arboladas, su arquitectura de estilo mediterráneo y una comunidad muy unida. Con casas frente a Biscayne Bay y el prestigioso Miami Shores Country Club, ofrece vida atemporal cerca del centro.",
    highlights: [
      "Historic village with Mediterranean-revival architecture",
      "Bayfront homes and Miami Shores Country Club",
      "Tree-lined streets and strong community events",
      "Minutes from Downtown Miami and the airport",
    ],
    highlights_es: [
      "Pueblo histórico con arquitectura de estilo mediterráneo",
      "Casas frente a la bahía y Miami Shores Country Club",
      "Calles arboladas y vida comunitaria activa",
      "A minutos del centro de Miami y el aeropuerto",
    ],
    services: [
      "Historic and Mediterranean-revival home sales",
      "Bayfront property brokerage",
      "Renovation and restoration consulting",
      "Bilingual real estate services (English & Spanish)",
      "Relocation assistance for buyers",
    ],
    services_es: [
      "Venta de casas históricas y de estilo mediterráneo",
      "Corretaje de propiedades frente a la bahía",
      "Asesoría en renovación y restauración",
      "Servicios inmobiliarios bilingües (inglés y español)",
      "Asistencia de reubicación para compradores",
    ],
    keywords: [
      "Miami Shores real estate",
      "Miami Shores homes for sale",
      "Miami Shores historic homes",
      "Miami Shores bayfront",
      "Miami-Dade village living",
    ],
    metaDescription:
      "Browse Miami Shores, FL real estate with PinPoint Realty. Historic Mediterranean homes, bayfront properties & charming village life. Bilingual agents.",
    metaDescription_es:
      "Explore bienes raíces en Miami Shores, FL con PinPoint Realty. Casas históricas mediterráneas, propiedades frente a la bahía y vida de pueblo encantadora. Agentes bilingües.",
  },
  {
    slug: "tamarac",
    name: "Tamarac",
    state: "Florida",
    county: "Broward County",
    description:
      "Tamarac is a welcoming city in central Broward County known for its 55+ communities, golf courses, and excellent value. With well-maintained neighborhoods and convenient access to Fort Lauderdale and the beaches, it's ideal for retirees and value-focused buyers.",
    description_es:
      "Tamarac es una ciudad acogedora en el centro de Broward, conocida por sus comunidades 55+, campos de golf y excelente valor. Con vecindarios bien cuidados y acceso conveniente a Fort Lauderdale y las playas, es ideal para jubilados y compradores enfocados en el valor.",
    highlights: [
      "Numerous 55+ active adult communities",
      "Multiple golf courses and recreation centers",
      "Affordable single-family homes and villas",
      "Central Broward location near major highways",
    ],
    highlights_es: [
      "Numerosas comunidades activas para mayores de 55",
      "Varios campos de golf y centros recreativos",
      "Casas unifamiliares y villas asequibles",
      "Ubicación central en Broward cerca de autopistas",
    ],
    services: [
      "55+ community villa and condo sales",
      "Single-family home brokerage",
      "Investment and rental property analysis",
      "Bilingual real estate services (English & Spanish)",
      "Relocation assistance for retirees",
    ],
    services_es: [
      "Venta de villas y condominios en comunidades 55+",
      "Corretaje de casas unifamiliares",
      "Análisis de propiedades de inversión y alquiler",
      "Servicios inmobiliarios bilingües (inglés y español)",
      "Asistencia de reubicación para jubilados",
    ],
    keywords: [
      "Tamarac real estate",
      "Tamarac homes for sale",
      "Tamarac 55+ communities",
      "Tamarac villas",
      "Broward County retirement",
    ],
    metaDescription:
      "Find Tamarac, FL homes with PinPoint Realty. 55+ communities, golf villas & affordable Broward County living. Expert bilingual agents.",
    metaDescription_es:
      "Encuentre casas en Tamarac, FL con PinPoint Realty. Comunidades 55+, villas de golf y vida asequible en Broward. Agentes bilingües expertos.",
  },
  {
    slug: "cooper-city",
    name: "Cooper City",
    state: "Florida",
    county: "Broward County",
    description:
      "Cooper City consistently ranks among the best places to live in Florida, thanks to its top-rated schools, low crime, and family-friendly neighborhoods. With well-planned subdivisions and easy access to all of Broward, it's a perennial favorite for relocating families.",
    description_es:
      "Cooper City se ubica constantemente entre los mejores lugares para vivir en Florida, gracias a sus escuelas top, baja criminalidad y vecindarios familiares. Con subdivisiones bien planificadas y fácil acceso a todo Broward, es un favorito perenne para familias que se mudan.",
    highlights: [
      "Top-rated public schools in Broward County",
      "Consistently ranked best places to live in Florida",
      "Master-planned, family-friendly subdivisions",
      "Low crime and strong community involvement",
    ],
    highlights_es: [
      "Escuelas públicas top en Broward",
      "Constantemente entre los mejores lugares para vivir en Florida",
      "Subdivisiones planificadas y familiares",
      "Baja criminalidad y fuerte comunidad",
    ],
    services: [
      "Family home sales in top school zones",
      "Buyer representation for relocating families",
      "Investment and rental property analysis",
      "Bilingual real estate services (English & Spanish)",
      "Competitive market analysis for Broward sellers",
    ],
    services_es: [
      "Venta de casas familiares en zonas escolares top",
      "Representación de compradores para familias que se mudan",
      "Análisis de propiedades de inversión y alquiler",
      "Servicios inmobiliarios bilingües (inglés y español)",
      "Análisis de mercado competitivo para vendedores en Broward",
    ],
    keywords: [
      "Cooper City real estate",
      "Cooper City homes for sale",
      "Cooper City schools",
      "Broward family homes",
      "best places to live Florida",
    ],
    metaDescription:
      "Discover Cooper City, FL real estate with PinPoint Realty. Top schools, family neighborhoods & one of Florida's best places to live. Bilingual agents.",
    metaDescription_es:
      "Descubra bienes raíces en Cooper City, FL con PinPoint Realty. Escuelas top, vecindarios familiares y uno de los mejores lugares para vivir en Florida. Agentes bilingües.",
  },
  {
    slug: "lighthouse-point",
    name: "Lighthouse Point",
    state: "Florida",
    county: "Broward County",
    description:
      "Lighthouse Point is an upscale waterfront community famous for its deep-water canals offering direct ocean access with no fixed bridges. It's a boater's paradise with luxury single-family homes, a yacht club atmosphere, and quiet, exclusive neighborhoods.",
    description_es:
      "Lighthouse Point es una comunidad exclusiva frente al agua famosa por sus canales de aguas profundas con acceso directo al océano sin puentes fijos. Es un paraíso para navegantes con casas de lujo, ambiente de club náutico y vecindarios tranquilos y exclusivos.",
    highlights: [
      "Deep-water canals with direct ocean access, no fixed bridges",
      "Active yacht club and boating community",
      "Luxury single-family waterfront homes",
      "Quiet, low-traffic neighborhoods",
    ],
    highlights_es: [
      "Canales de aguas profundas con acceso directo al océano, sin puentes fijos",
      "Club náutico activo y comunidad navegante",
      "Casas de lujo unifamiliares frente al agua",
      "Vecindarios tranquilos y de bajo tráfico",
    ],
    services: [
      "Deep-water waterfront home sales",
      "Boater-focused buyer representation",
      "Luxury property valuation and brokerage",
      "Bilingual real estate services (English & Spanish)",
      "Discreet representation for high-net-worth clients",
    ],
    services_es: [
      "Venta de casas frente al agua de aguas profundas",
      "Representación enfocada en navegantes",
      "Valuación y corretaje de propiedades de lujo",
      "Servicios inmobiliarios bilingües (inglés y español)",
      "Representación discreta para clientes de alto patrimonio",
    ],
    keywords: [
      "Lighthouse Point real estate",
      "Lighthouse Point waterfront homes",
      "Lighthouse Point luxury",
      "Broward boater homes",
      "deep water Broward",
    ],
    metaDescription:
      "Browse Lighthouse Point, FL waterfront homes with PinPoint Realty. Deep-water canals, ocean access & luxury boater estates in Broward. Bilingual agents.",
    metaDescription_es:
      "Explore casas frente al agua en Lighthouse Point, FL con PinPoint Realty. Canales profundos, acceso al océano y propiedades de lujo para navegantes. Agentes bilingües.",
  },
  {
    slug: "wilton-manors",
    name: "Wilton Manors",
    state: "Florida",
    county: "Broward County",
    description:
      "Wilton Manors is a vibrant, walkable city known as one of the most LGBTQ-friendly communities in the country. With its lively Wilton Drive entertainment district, charming mid-century homes, and waterfront properties along the Middle River, it offers a unique urban-village lifestyle.",
    description_es:
      "Wilton Manors es una ciudad vibrante y peatonal, reconocida como una de las comunidades más amigables con la comunidad LGBTQ del país. Con su animado distrito de entretenimiento Wilton Drive, encantadoras casas mid-century y propiedades frente al Middle River, ofrece un estilo de vida único de pueblo urbano.",
    highlights: [
      "Vibrant, walkable Wilton Drive entertainment district",
      "One of the most LGBTQ-friendly cities in the U.S.",
      "Mid-century homes and waterfront on the Middle River",
      "Adjacent to Fort Lauderdale and the beach",
    ],
    highlights_es: [
      "Vibrante distrito peatonal Wilton Drive",
      "Una de las ciudades más amigables con la comunidad LGBTQ en EE.UU.",
      "Casas mid-century y propiedades frente al Middle River",
      "Junto a Fort Lauderdale y la playa",
    ],
    services: [
      "Mid-century and renovated home sales",
      "Middle River waterfront brokerage",
      "Investment and rental property analysis",
      "Bilingual real estate services (English & Spanish)",
      "LGBTQ-affirming buyer and seller representation",
    ],
    services_es: [
      "Venta de casas mid-century y renovadas",
      "Corretaje de propiedades frente al Middle River",
      "Análisis de propiedades de inversión y alquiler",
      "Servicios inmobiliarios bilingües (inglés y español)",
      "Representación afirmativa LGBTQ para compradores y vendedores",
    ],
    keywords: [
      "Wilton Manors real estate",
      "Wilton Manors homes for sale",
      "Wilton Manors waterfront",
      "Wilton Drive condos",
      "LGBTQ-friendly Broward",
    ],
    metaDescription:
      "Find Wilton Manors, FL homes with PinPoint Realty. Mid-century gems, Middle River waterfront & vibrant village living in Broward. Bilingual agents.",
    metaDescription_es:
      "Encuentre casas en Wilton Manors, FL con PinPoint Realty. Joyas mid-century, propiedades frente al Middle River y vida vibrante en Broward. Agentes bilingües.",
  },
  {
    slug: "dania-beach",
    name: "Dania Beach",
    state: "Florida",
    county: "Broward County",
    description:
      "Dania Beach is a coastal city sandwiched between Fort Lauderdale and Hollywood, offering beach access, the popular Dania Pointe development, and strong investment potential. With both established neighborhoods and new construction, it's an emerging hotspot in Broward.",
    description_es:
      "Dania Beach es una ciudad costera ubicada entre Fort Lauderdale y Hollywood, con acceso a la playa, el popular desarrollo Dania Pointe y un fuerte potencial de inversión. Con vecindarios establecidos y obra nueva, es un punto emergente en Broward.",
    highlights: [
      "Direct beach access and waterfront properties",
      "Booming Dania Pointe shopping & dining destination",
      "Located between Fort Lauderdale and Hollywood",
      "Strong rental and investment market near the airport",
    ],
    highlights_es: [
      "Acceso directo a la playa y propiedades frente al agua",
      "Auge de Dania Pointe con comercio y gastronomía",
      "Ubicada entre Fort Lauderdale y Hollywood",
      "Fuerte mercado de alquiler e inversión cerca del aeropuerto",
    ],
    services: [
      "Beach condo and waterfront home sales",
      "Investment and short-term rental analysis",
      "New construction representation at Dania Pointe",
      "Bilingual real estate services (English & Spanish)",
      "Buyer representation for relocating professionals",
    ],
    services_es: [
      "Venta de condominios de playa y casas frente al agua",
      "Análisis de inversión y alquiler a corto plazo",
      "Representación en obra nueva en Dania Pointe",
      "Servicios inmobiliarios bilingües (inglés y español)",
      "Representación para profesionales que se mudan",
    ],
    keywords: [
      "Dania Beach real estate",
      "Dania Beach condos",
      "Dania Pointe homes",
      "Broward beachfront",
      "Dania Beach investment",
    ],
    metaDescription:
      "Discover Dania Beach, FL real estate with PinPoint Realty. Beach condos, Dania Pointe homes & investment properties in Broward. Bilingual agents.",
    metaDescription_es:
      "Descubra bienes raíces en Dania Beach, FL con PinPoint Realty. Condominios de playa, casas en Dania Pointe e inversiones en Broward. Agentes bilingües.",
  },
  {
    slug: "oakland-park",
    name: "Oakland Park",
    state: "Florida",
    county: "Broward County",
    description:
      "Oakland Park is a creative, evolving city just north of Fort Lauderdale, known for its emerging Culinary Arts District, mid-century homes, and waterfront properties along the Middle River. It offers exceptional value with quick access to the beach and Downtown.",
    description_es:
      "Oakland Park es una ciudad creativa y en evolución justo al norte de Fort Lauderdale, conocida por su emergente Culinary Arts District, casas mid-century y propiedades frente al Middle River. Ofrece un valor excepcional con acceso rápido a la playa y al centro.",
    highlights: [
      "Emerging Culinary Arts District",
      "Mid-century architecture and waterfront homes",
      "Excellent value adjacent to Fort Lauderdale",
      "Walkable, increasingly vibrant downtown",
    ],
    highlights_es: [
      "Emergente Culinary Arts District",
      "Arquitectura mid-century y casas frente al agua",
      "Excelente valor junto a Fort Lauderdale",
      "Centro peatonal cada vez más vibrante",
    ],
    services: [
      "Mid-century and renovation home sales",
      "Waterfront property brokerage on the Middle River",
      "Investment and rental property analysis",
      "Bilingual real estate services (English & Spanish)",
      "Buyer representation for first-time and relocating buyers",
    ],
    services_es: [
      "Venta de casas mid-century y para renovación",
      "Corretaje de propiedades frente al Middle River",
      "Análisis de propiedades de inversión y alquiler",
      "Servicios inmobiliarios bilingües (inglés y español)",
      "Representación para compradores primerizos y que se mudan",
    ],
    keywords: [
      "Oakland Park real estate",
      "Oakland Park homes for sale",
      "Oakland Park mid-century",
      "Oakland Park waterfront",
      "Broward Culinary Arts District",
    ],
    metaDescription:
      "Browse Oakland Park, FL real estate with PinPoint Realty. Mid-century homes, Middle River waterfront & emerging Culinary Arts District. Bilingual agents.",
    metaDescription_es:
      "Explore bienes raíces en Oakland Park, FL con PinPoint Realty. Casas mid-century, propiedades frente al Middle River y el emergente Culinary Arts District. Agentes bilingües.",
  },
  {
    slug: "singer-island",
    name: "Singer Island",
    state: "Florida",
    county: "Palm Beach County",
    description:
      "Singer Island is a luxury barrier-island enclave in Riviera Beach offering oceanfront condo towers, pristine beaches, and resort-style living. With branded residences and direct ocean access, it's one of Palm Beach County's most desirable condo markets.",
    description_es:
      "Singer Island es un enclave de lujo en una isla barrera de Riviera Beach, con torres de condominios frente al mar, playas vírgenes y vida tipo resort. Con residencias de marca y acceso directo al océano, es uno de los mercados de condominios más deseados de Palm Beach.",
    highlights: [
      "Oceanfront condo towers with resort amenities",
      "Pristine, less-crowded beaches",
      "Branded residences and luxury developments",
      "Direct access to MacArthur Beach State Park",
    ],
    highlights_es: [
      "Torres de condominios frente al mar con servicios tipo resort",
      "Playas vírgenes y poco concurridas",
      "Residencias de marca y desarrollos de lujo",
      "Acceso directo al Parque Estatal MacArthur Beach",
    ],
    services: [
      "Luxury oceanfront condo sales",
      "Branded residence and pre-construction representation",
      "Investment and rental property analysis",
      "Bilingual real estate services (English & Spanish)",
      "Discreet representation for high-net-worth clients",
    ],
    services_es: [
      "Venta de condominios de lujo frente al mar",
      "Representación en residencias de marca y preconstrucción",
      "Análisis de propiedades de inversión y alquiler",
      "Servicios inmobiliarios bilingües (inglés y español)",
      "Representación discreta para clientes de alto patrimonio",
    ],
    keywords: [
      "Singer Island real estate",
      "Singer Island condos",
      "Singer Island oceanfront",
      "Riviera Beach luxury",
      "Palm Beach County condos",
    ],
    metaDescription:
      "Find Singer Island, FL luxury condos with PinPoint Realty. Oceanfront towers, branded residences & resort living in Palm Beach. Bilingual agents.",
    metaDescription_es:
      "Encuentre condominios de lujo en Singer Island, FL con PinPoint Realty. Torres frente al mar, residencias de marca y vida tipo resort en Palm Beach. Agentes bilingües.",
  },
  {
    slug: "lake-park",
    name: "Lake Park",
    state: "Florida",
    county: "Palm Beach County",
    description:
      "Lake Park is a small, charming town on the Intracoastal Waterway with a marina, parks, and historic homes. Located between Riviera Beach and North Palm Beach, it offers waterfront access and an authentic, small-town feel at attractive prices.",
    description_es:
      "Lake Park es un pequeño y encantador pueblo a orillas del Intracoastal con marina, parques y casas históricas. Ubicado entre Riviera Beach y North Palm Beach, ofrece acceso al agua y un auténtico ambiente de pueblo a precios atractivos.",
    highlights: [
      "Located on the Intracoastal Waterway with a marina",
      "Historic homes and small-town charm",
      "Attractive value compared to neighboring towns",
      "Easy access to Singer Island and Palm Beach Gardens",
    ],
    highlights_es: [
      "Sobre el Intracoastal con marina",
      "Casas históricas y encanto de pueblo",
      "Valor atractivo frente a pueblos vecinos",
      "Fácil acceso a Singer Island y Palm Beach Gardens",
    ],
    services: [
      "Historic and waterfront home sales",
      "Marina-area property brokerage",
      "First-time homebuyer representation",
      "Bilingual real estate services (English & Spanish)",
      "Investment and rental property analysis",
    ],
    services_es: [
      "Venta de casas históricas y frente al agua",
      "Corretaje de propiedades cerca de la marina",
      "Representación para compradores primerizos",
      "Servicios inmobiliarios bilingües (inglés y español)",
      "Análisis de propiedades de inversión y alquiler",
    ],
    keywords: [
      "Lake Park FL real estate",
      "Lake Park homes for sale",
      "Lake Park waterfront",
      "Lake Park marina homes",
      "Palm Beach County value",
    ],
    metaDescription:
      "Discover Lake Park, FL real estate with PinPoint Realty. Waterfront homes, historic charm & marina living in Palm Beach County. Bilingual agents.",
    metaDescription_es:
      "Descubra bienes raíces en Lake Park, FL con PinPoint Realty. Casas frente al agua, encanto histórico y vida cerca de la marina en Palm Beach. Agentes bilingües.",
  },
  {
    slug: "royal-palm-beach",
    name: "Royal Palm Beach",
    state: "Florida",
    county: "Palm Beach County",
    description:
      "Royal Palm Beach is a family-friendly western Palm Beach County village known for its parks, equestrian roots, and master-planned communities. It offers excellent value with newer single-family homes and townhouses near Wellington and Loxahatchee.",
    description_es:
      "Royal Palm Beach es un pueblo familiar al oeste de Palm Beach, conocido por sus parques, raíces ecuestres y comunidades planificadas. Ofrece excelente valor con casas unifamiliares y townhomes nuevos cerca de Wellington y Loxahatchee.",
    highlights: [
      "Family-friendly with extensive parks and trails",
      "Equestrian-friendly communities near Wellington",
      "Newer master-planned subdivisions",
      "Strong value in western Palm Beach County",
    ],
    highlights_es: [
      "Familiar, con amplios parques y senderos",
      "Comunidades ecuestres cerca de Wellington",
      "Nuevas subdivisiones planificadas",
      "Sólido valor en el oeste de Palm Beach",
    ],
    services: [
      "Single-family and townhome sales",
      "Equestrian-property brokerage",
      "Investment and rental property analysis",
      "Bilingual real estate services (English & Spanish)",
      "Relocation assistance for families",
    ],
    services_es: [
      "Venta de casas unifamiliares y townhomes",
      "Corretaje de propiedades ecuestres",
      "Análisis de propiedades de inversión y alquiler",
      "Servicios inmobiliarios bilingües (inglés y español)",
      "Asistencia de reubicación para familias",
    ],
    keywords: [
      "Royal Palm Beach real estate",
      "Royal Palm Beach homes for sale",
      "Royal Palm Beach townhomes",
      "western Palm Beach County",
      "RPB family homes",
    ],
    metaDescription:
      "Browse Royal Palm Beach, FL real estate with PinPoint Realty. Family homes, townhomes & equestrian-friendly communities. Bilingual agents.",
    metaDescription_es:
      "Explore bienes raíces en Royal Palm Beach, FL con PinPoint Realty. Casas familiares, townhomes y comunidades ecuestres. Agentes bilingües.",
  },
  {
    slug: "greenacres",
    name: "Greenacres",
    state: "Florida",
    county: "Palm Beach County",
    description:
      "Greenacres is a diverse, family-oriented city in central Palm Beach County offering some of the most affordable single-family homes in the area. With parks, sports facilities, and easy access to West Palm Beach and Lake Worth, it's a top choice for value-focused buyers.",
    description_es:
      "Greenacres es una ciudad diversa y familiar en el centro de Palm Beach con algunas de las casas unifamiliares más asequibles de la zona. Con parques, instalaciones deportivas y fácil acceso a West Palm Beach y Lake Worth, es una opción destacada para compradores enfocados en el valor.",
    highlights: [
      "Affordable single-family homes in Palm Beach County",
      "Diverse, family-oriented community",
      "Numerous parks and recreation facilities",
      "Convenient access to I-95 and the Turnpike",
    ],
    highlights_es: [
      "Casas unifamiliares asequibles en Palm Beach",
      "Comunidad diversa y familiar",
      "Numerosos parques y centros recreativos",
      "Fácil acceso a I-95 y al Turnpike",
    ],
    services: [
      "Single-family and starter home sales",
      "First-time homebuyer FHA/VA representation",
      "Investment and rental property analysis",
      "Bilingual real estate services (English & Spanish)",
      "Relocation assistance for working families",
    ],
    services_es: [
      "Venta de casas unifamiliares y de inicio",
      "Representación FHA/VA para compradores primerizos",
      "Análisis de propiedades de inversión y alquiler",
      "Servicios inmobiliarios bilingües (inglés y español)",
      "Asistencia de reubicación para familias trabajadoras",
    ],
    keywords: [
      "Greenacres FL real estate",
      "Greenacres homes for sale",
      "Greenacres affordable homes",
      "Palm Beach County starter homes",
      "first-time buyer Palm Beach",
    ],
    metaDescription:
      "Find Greenacres, FL homes with PinPoint Realty. Affordable single-family homes, family neighborhoods & first-time buyer options. Bilingual agents.",
    metaDescription_es:
      "Encuentre casas en Greenacres, FL con PinPoint Realty. Casas unifamiliares asequibles, vecindarios familiares y opciones para compradores primerizos. Agentes bilingües.",
  },
  {
    slug: "lantana",
    name: "Lantana",
    state: "Florida",
    county: "Palm Beach County",
    description:
      "Lantana is a small coastal town just south of Lake Worth with beach access, the historic Old Key Lime House on the Intracoastal, and a quiet Old Florida vibe. It offers an attractive mix of beach condos, waterfront homes, and affordable mainland properties.",
    description_es:
      "Lantana es un pequeño pueblo costero justo al sur de Lake Worth, con acceso a la playa, la histórica Old Key Lime House en el Intracoastal y un ambiente tranquilo de la 'Old Florida'. Ofrece una atractiva mezcla de condominios de playa, casas frente al agua y propiedades asequibles.",
    highlights: [
      "Beach access and Intracoastal waterfront",
      "Quiet, Old Florida small-town vibe",
      "Affordable mix of condos and single-family homes",
      "Adjacent to Manalapan and Hypoluxo Island",
    ],
    highlights_es: [
      "Acceso a la playa y al Intracoastal",
      "Ambiente tranquilo de la 'Old Florida'",
      "Mezcla asequible de condominios y casas",
      "Junto a Manalapan e Hypoluxo Island",
    ],
    services: [
      "Beach condo and waterfront home sales",
      "Investment and short-term rental analysis",
      "Single-family mainland home brokerage",
      "Bilingual real estate services (English & Spanish)",
      "Relocation assistance for coastal buyers",
    ],
    services_es: [
      "Venta de condominios de playa y casas frente al agua",
      "Análisis de inversión y alquiler a corto plazo",
      "Corretaje de casas en tierra firme",
      "Servicios inmobiliarios bilingües (inglés y español)",
      "Asistencia de reubicación para compradores costeros",
    ],
    keywords: [
      "Lantana FL real estate",
      "Lantana homes for sale",
      "Lantana waterfront",
      "Lantana beach condos",
      "Palm Beach County coastal",
    ],
    metaDescription:
      "Discover Lantana, FL real estate with PinPoint Realty. Beach condos, Intracoastal waterfront & Old Florida coastal living. Bilingual agents.",
    metaDescription_es:
      "Descubra bienes raíces en Lantana, FL con PinPoint Realty. Condominios de playa, propiedades frente al Intracoastal y vida costera de 'Old Florida'. Agentes bilingües.",
  },
  {
    slug: "manalapan",
    name: "Manalapan",
    state: "Florida",
    county: "Palm Beach County",
    description:
      "Manalapan is one of Florida's most exclusive ultra-luxury enclaves, a barrier island town between the Atlantic and the Intracoastal Waterway. Known for sprawling oceanfront estates and the iconic Eau Palm Beach Resort, it offers extreme privacy and prestige.",
    description_es:
      "Manalapan es uno de los enclaves de ultra-lujo más exclusivos de Florida: un pueblo en isla barrera entre el Atlántico y el Intracoastal. Conocido por enormes mansiones frente al mar y el icónico Eau Palm Beach Resort, ofrece máxima privacidad y prestigio.",
    highlights: [
      "Ultra-luxury oceanfront and ocean-to-Intracoastal estates",
      "Home to the Eau Palm Beach Resort",
      "Extreme privacy and gated security",
      "One of Florida's most exclusive addresses",
    ],
    highlights_es: [
      "Mansiones ultra-lujo de océano a Intracoastal",
      "Sede del Eau Palm Beach Resort",
      "Máxima privacidad y seguridad",
      "Una de las direcciones más exclusivas de Florida",
    ],
    services: [
      "Ultra-luxury oceanfront estate sales",
      "Discreet, off-market representation",
      "International buyer concierge services",
      "Bilingual real estate services (English & Spanish)",
      "High-net-worth buyer and seller advisory",
    ],
    services_es: [
      "Venta de mansiones ultra-lujo frente al mar",
      "Representación discreta y off-market",
      "Servicios concierge para compradores internacionales",
      "Servicios inmobiliarios bilingües (inglés y español)",
      "Asesoría para clientes de alto patrimonio",
    ],
    keywords: [
      "Manalapan real estate",
      "Manalapan oceanfront estates",
      "Manalapan luxury homes",
      "Eau Palm Beach",
      "Palm Beach ultra-luxury",
    ],
    metaDescription:
      "Browse Manalapan, FL ultra-luxury real estate with PinPoint Realty. Oceanfront estates, ocean-to-Intracoastal homes & discreet representation.",
    metaDescription_es:
      "Explore bienes raíces ultra-lujo en Manalapan, FL con PinPoint Realty. Mansiones frente al mar, propiedades de océano a Intracoastal y representación discreta.",
  },
  {
    slug: "islamorada",
    name: "Islamorada",
    state: "Florida",
    county: "Monroe County",
    description:
      "Islamorada, the 'Village of Islands,' is the sport-fishing capital of the world and one of the most desirable destinations in the Florida Keys. With oceanfront and bayfront estates, charming bungalows, and world-class fishing, it's a true tropical paradise.",
    description_es:
      "Islamorada, la 'Aldea de las Islas', es la capital mundial de la pesca deportiva y uno de los destinos más deseados de los Cayos de Florida. Con mansiones frente al océano y a la bahía, encantadores bungalows y pesca de clase mundial, es un verdadero paraíso tropical.",
    highlights: [
      "Sport-fishing capital of the world",
      "Oceanfront and bayfront luxury estates",
      "Charming Keys bungalows and cottages",
      "Iconic spots like Founders Park and Anne's Beach",
    ],
    highlights_es: [
      "Capital mundial de la pesca deportiva",
      "Mansiones de lujo frente al océano y a la bahía",
      "Encantadores bungalows y cabañas de los Cayos",
      "Lugares icónicos como Founders Park y Anne's Beach",
    ],
    services: [
      "Oceanfront and bayfront estate sales",
      "Keys cottage and bungalow brokerage",
      "Investment and short-term rental analysis",
      "Bilingual real estate services (English & Spanish)",
      "Boat-dock and waterfront-focused buyer representation",
    ],
    services_es: [
      "Venta de mansiones frente al océano y a la bahía",
      "Corretaje de cabañas y bungalows en los Cayos",
      "Análisis de inversión y alquiler a corto plazo",
      "Servicios inmobiliarios bilingües (inglés y español)",
      "Representación enfocada en muelles y propiedades frente al agua",
    ],
    keywords: [
      "Islamorada real estate",
      "Islamorada homes for sale",
      "Islamorada waterfront",
      "Florida Keys luxury",
      "Islamorada oceanfront",
    ],
    metaDescription:
      "Find Islamorada, FL real estate with PinPoint Realty. Oceanfront estates, Keys cottages & sport-fishing paradise homes in Monroe County. Bilingual agents.",
    metaDescription_es:
      "Encuentre bienes raíces en Islamorada, FL con PinPoint Realty. Mansiones frente al mar, cabañas en los Cayos y casas en la capital de la pesca. Agentes bilingües.",
  },
  {
    slug: "marathon",
    name: "Marathon",
    state: "Florida",
    county: "Monroe County",
    description:
      "Marathon is the heart of the Middle Keys, known for its family-friendly atmosphere, Sombrero Beach, and the Turtle Hospital. With canal-front homes, oceanfront condos, and easy access to both Key West and Key Largo, it's a balanced Keys lifestyle destination.",
    description_es:
      "Marathon es el corazón de los Cayos Medios, conocido por su ambiente familiar, Sombrero Beach y el Turtle Hospital. Con casas frente al canal, condominios frente al mar y fácil acceso a Key West y Key Largo, ofrece un estilo de vida equilibrado en los Cayos.",
    highlights: [
      "Heart of the Middle Keys with family-friendly amenities",
      "Sombrero Beach, Turtle Hospital and Dolphin Research Center",
      "Canal-front homes with deep-water dockage",
      "Mid-point between Key West and Key Largo",
    ],
    highlights_es: [
      "Corazón de los Cayos Medios con servicios familiares",
      "Sombrero Beach, Turtle Hospital y Dolphin Research Center",
      "Casas frente al canal con muelles de aguas profundas",
      "Punto medio entre Key West y Key Largo",
    ],
    services: [
      "Canal-front and oceanfront home sales",
      "Vacation rental and investment property analysis",
      "Condo and townhome brokerage",
      "Bilingual real estate services (English & Spanish)",
      "Relocation assistance for Keys lifestyle buyers",
    ],
    services_es: [
      "Venta de casas frente al canal y al océano",
      "Análisis de propiedades de inversión y alquiler vacacional",
      "Corretaje de condominios y townhomes",
      "Servicios inmobiliarios bilingües (inglés y español)",
      "Asistencia de reubicación para compradores en los Cayos",
    ],
    keywords: [
      "Marathon FL real estate",
      "Marathon Keys homes",
      "Marathon waterfront",
      "Middle Keys real estate",
      "Marathon canal homes",
    ],
    metaDescription:
      "Discover Marathon, FL real estate with PinPoint Realty. Canal-front homes, oceanfront condos & family Keys living in Monroe County. Bilingual agents.",
    metaDescription_es:
      "Descubra bienes raíces en Marathon, FL con PinPoint Realty. Casas frente al canal, condominios frente al mar y vida familiar en los Cayos. Agentes bilingües.",
  },
  {
    slug: "big-pine-key",
    name: "Big Pine Key",
    state: "Florida",
    county: "Monroe County",
    description:
      "Big Pine Key is a quiet, nature-lover's paradise in the Lower Keys, home to the National Key Deer Refuge and Bahia Honda State Park nearby. With canal-front homes, stilt houses, and authentic Old Keys charm, it offers a slower, more secluded island lifestyle.",
    description_es:
      "Big Pine Key es un tranquilo paraíso para amantes de la naturaleza en los Lower Keys, hogar del National Key Deer Refuge y cerca del parque estatal Bahia Honda. Con casas frente al canal, casas sobre pilotes y auténtico encanto de los Old Keys, ofrece un estilo de vida insular más tranquilo y apartado.",
    highlights: [
      "Home to the National Key Deer Refuge",
      "Near Bahia Honda State Park's famous beaches",
      "Canal-front and stilt homes with authentic Keys charm",
      "Quiet, secluded Lower Keys lifestyle",
    ],
    highlights_es: [
      "Sede del National Key Deer Refuge",
      "Cerca de las famosas playas de Bahia Honda State Park",
      "Casas frente al canal y sobre pilotes con auténtico encanto",
      "Estilo de vida tranquilo y apartado en los Lower Keys",
    ],
    services: [
      "Canal-front and stilt-home sales",
      "Vacant Keys land brokerage and ROGO consulting",
      "Vacation rental and investment property analysis",
      "Bilingual real estate services (English & Spanish)",
      "Relocation assistance for Lower Keys buyers",
    ],
    services_es: [
      "Venta de casas frente al canal y sobre pilotes",
      "Corretaje de terrenos en los Cayos y asesoría ROGO",
      "Análisis de propiedades de inversión y alquiler vacacional",
      "Servicios inmobiliarios bilingües (inglés y español)",
      "Asistencia de reubicación para compradores en los Lower Keys",
    ],
    keywords: [
      "Big Pine Key real estate",
      "Big Pine Key homes",
      "Lower Keys real estate",
      "Big Pine Key waterfront",
      "Key deer refuge homes",
    ],
    metaDescription:
      "Browse Big Pine Key, FL real estate with PinPoint Realty. Canal-front homes, stilt houses & nature-lover Keys living in Monroe. Bilingual agents.",
    metaDescription_es:
      "Explore bienes raíces en Big Pine Key, FL con PinPoint Realty. Casas frente al canal, casas sobre pilotes y vida insular natural en los Cayos. Agentes bilingües.",
  },
  {
    slug: "key-west",
    name: "Key West",
    state: "Florida",
    county: "Monroe County",
    description:
      "Key West is the southernmost city in the continental United States, famous for its historic conch architecture, vibrant arts scene, sunset celebrations, and tropical lifestyle. From Old Town historic homes to oceanfront condos and luxury estates, it's a bucket-list market.",
    description_es:
      "Key West es la ciudad más austral de los Estados Unidos continentales, famosa por su arquitectura histórica 'conch', vibrante escena artística, las celebraciones del atardecer y su estilo de vida tropical. Desde casas históricas en Old Town hasta condominios frente al mar y mansiones de lujo, es un mercado de lista de deseos.",
    highlights: [
      "Historic Old Town with iconic conch architecture",
      "Southernmost city in the continental U.S.",
      "Vibrant arts, dining, and Duval Street nightlife",
      "Strong vacation-rental and luxury second-home market",
    ],
    highlights_es: [
      "Old Town histórico con icónica arquitectura 'conch'",
      "Ciudad más austral de los EE.UU. continentales",
      "Vibrante arte, gastronomía y vida nocturna en Duval Street",
      "Fuerte mercado de alquiler vacacional y segundas residencias de lujo",
    ],
    services: [
      "Historic Old Town home sales and restoration consulting",
      "Oceanfront and waterfront condo brokerage",
      "Vacation rental and investment property analysis",
      "Bilingual real estate services (English & Spanish)",
      "Discreet representation for second-home and luxury buyers",
    ],
    services_es: [
      "Venta de casas históricas en Old Town y asesoría de restauración",
      "Corretaje de condominios frente al mar y al agua",
      "Análisis de inversión y alquiler vacacional",
      "Servicios inmobiliarios bilingües (inglés y español)",
      "Representación discreta para segundas residencias y compradores de lujo",
    ],
    keywords: [
      "Key West real estate",
      "Key West homes for sale",
      "Old Town Key West",
      "Key West waterfront",
      "Key West luxury condos",
    ],
    metaDescription:
      "Find Key West, FL real estate with PinPoint Realty. Historic Old Town homes, oceanfront condos & luxury estates in Monroe County. Bilingual agents.",
    metaDescription_es:
      "Encuentre bienes raíces en Key West, FL con PinPoint Realty. Casas históricas en Old Town, condominios frente al mar y mansiones de lujo en los Cayos. Agentes bilingües.",
  },
];

export function getCityBySlug(slug: string): CityData | undefined {
  return CITY_DATA.find((c) => c.slug === slug);
}
